import { isBeforeDate as Lr, parseDate as me, DateFormat as ne, isAfterDate as Ur, CharacterRestrictionHelper as Pr, PLACEHOLDER_CHARACTER as Br, formatDate as $e, humanizeString as Wr, convertObjectKeysCase as je, CaseStyle as Dt, FormModalBody as Wt, getTestAttributes as x, Input as be, noop as E, sizing as y, fontWeights as Ze, colors as R, breakpoints as Hr, Option as ut, InputType as jr, SelectInput as mt, useValidation as Gr, ModalStepBuilder as zr, StepModal as Yr, SkeletonLoader as Ie, ButtonType as Ce, Tooltip as gt, TooltipPlace as pt, Button as ht, DropdownOption as k, DropdownWithOptions as Ht, IconButton as jt, icons as q, ButtonSize as Gt, Separator as J, fontSizing as pe, convertRemToPx as xt, CheckboxInput as Kr, slug as K, InputLabel as Jr, randomUUID as Xr, RadioInput as Vt, FormattedInput as Qr, TextAreaInput as zt, DatePickerInput as Zr, AttentionModal as en, useMounted as Le, useToast as Yt, Card as we, CardWithTitle as Kt, CardDescriptionType as tn, FilterList as rn, SelectableCard as nn } from "@chillibean/component-library";
import i from "prop-types";
import { jsx as a, jsxs as C, Fragment as ie } from "react/jsx-runtime";
import "@chillibean/component-library/index.css";
import Re, { useMemo as ue, useRef as yt, useState as D, useCallback as kt, useEffect as V, forwardRef as on, useImperativeHandle as sn } from "react";
import { useSelector as $, useDispatch as Se, Provider as an } from "react-redux";
import { useHistory as he, Prompt as dn, useParams as et, useRouteMatch as Ee, Switch as ln, Route as $t, Redirect as Mt } from "react-router-dom";
import Jt from "axios";
import { combineReducers as cn, createStore as un, applyMiddleware as mn, compose as pn } from "redux";
import hn from "redux-thunk";
import { useForm as Qe } from "react-hook-form";
import p from "styled-components";
import { Signature as fn, MultiSelect as gn, lower as Fe, Accordion as yn } from "@chillibean/component-library/legacy";
import { detectOverflow as Fn } from "@popperjs/core";
import { clsx as Ft } from "clsx";
import { Icon as Te } from "@iconify/react";
import { easeQuadInOut as Cn } from "d3-ease";
import { animated as bn, useSpring as wn } from "react-spring";
import { useMeasure as Tn } from "react-use";
const te = {
  CHECKBOX: "checkbox",
  DATE: "date",
  DESCRIPTIVE: "descriptive",
  DROPDOWN: "dropdown",
  RADIO: "radio",
  SINGLE_LINE: "single_line"
}, Me = {
  NOT_FUTURE_DATE: "not_future_date",
  NOT_PAST_DATE: "not_past_date"
};
class vn {
  constructor(e = {}) {
    this.characterLimit = e.characterLimit, this.characterRestriction = e.characterRestriction, this.dateRestriction = e.dateRestriction && Me[e.dateRestriction.toUpperCase()], this.inputFormat = e.inputFormat, this.required = e.required;
  }
  isFormatted() {
    return this.characterRestriction;
  }
}
class P {
  constructor(e = {}) {
    this.comments = e.comments || [], this.enabled = e.enabled, this.id = e.id, this.inputGuidance = e.inputGuidance, this.options = e.options || [], this.otherEnabled = e.otherEnabled, this.otherField = e.otherField, this.title = e.title, this.type = te[e.type.toUpperCase()], this.validations = new vn(e.validations), this.value = e.value;
  }
}
class Xt extends P {
  constructor(e = {}) {
    super(e);
  }
  /* eslint-disable-next-line class-methods-use-this  */
  validate() {
    return !0;
  }
}
class Qt extends P {
  constructor(e = {}) {
    super(e);
  }
  /**
   * Validate field.
   * @override
   * @param {string} value - Field value.
   * @returns {boolean|string} - Validation result.
   */
  validate(e) {
    const t = /* @__PURE__ */ new Date();
    return t.setHours(0, 0, 0, 0), Me.NOT_PAST_DATE === this.validations.dateRestriction && Lr(me(e, ne.ISO_DATE), t) ? "Must be current or future date" : Me.NOT_FUTURE_DATE === this.validations.dateRestriction && Ur(me(e, ne.ISO_DATE), t) ? "Must be current or past date" : !0;
  }
}
class Zt extends P {
  constructor(e = {}) {
    super(e);
  }
  /* eslint-disable-next-line class-methods-use-this  */
  validate() {
    return !0;
  }
}
class er extends P {
  constructor(e = {}) {
    super(e);
  }
  /* eslint-disable-next-line class-methods-use-this  */
  validate() {
    return !0;
  }
}
class tr extends P {
  constructor(e = {}) {
    super(e), this.otherOptionChecked = !1;
  }
  setOtherOptionChecked(e) {
    this.otherOptionChecked = e;
  }
  validate(e) {
    const t = e.length;
    return !this.validations.required && this.otherOptionChecked && t === 0 ? `Please enter a value for the ${this.otherField} option.` : !0;
  }
}
class rr extends P {
  constructor(e = {}) {
    super(e);
  }
  isFormatted() {
    return this.validations.isFormatted();
  }
  /**
   * Validate field.
   * @override
   * @param {string} value - Field value.
   * @returns {boolean|string} - Validation result.
   */
  validate(e) {
    const t = e.length;
    if (!(this.validations.required || t) || !this.validations.characterLimit || !this.validations.inputFormat) return !0;
    const s = new RegExp(this.validations.inputFormat, "i"), n = Pr.splitRegex(
      this.validations.inputFormat,
      this.validations.characterLimit
    ).map((d) => `[${d.symbol}]`);
    return e.replace(Br, "").length !== this.validations.characterLimit ? `Must be {${this.validations.characterLimit}} characters` : e.match(s) ? !0 : `Must be in the following format: ${n.join("")}`;
  }
}
class nr {
  static create(e) {
    switch (e.type) {
      case te.CHECKBOX:
        return new Xt(e);
      case te.DATE:
        return new Qt(e);
      case te.DESCRIPTIVE:
        return new Zt(e);
      case te.DROPDOWN:
        return new er(e);
      case te.RADIO:
        return new tr(e);
      case te.SINGLE_LINE:
        return new rr(e);
      default:
        return new P(e);
    }
  }
}
let Rn = class {
  constructor(e) {
    this.activityText = e.transitionActivityText.toLowerCase(), this.createdAt = e.createdAt && me(e.createdAt), this.id = e.id, this.reasonForChange = e.reasonForChange, this.userEmail = e.userEmail, this.version = e.objectVersionNumber;
  }
  getFormattedHistory(e) {
    const t = [];
    return t.push(e, this.getFormattedVersion("v"), "-", this.userEmail, this.activityText), this.reasonForChange && t.push(`with reason '${this.reasonForChange}'`), t.push("on", $e(this.createdAt, ne.DATE_TIME)), t.join(" ");
  }
  getFormattedVersion(e = "") {
    return this.version === 0 ? "DRAFT" : `${e}${this.version}`;
  }
};
class ir {
  constructor(e) {
    this.id = e.id, this.email = e.email, this.firstName = e.firstName, this.lastName = e.lastName, this.meaning = e.meaning, this.reason = e.reason, this.createdAt = e.createdAt && me(e.createdAt), this.verificationStatus = e.verificationStatus, this.userUuid = e.userUuid, this.objectUuid = e.objectUuid;
  }
}
const le = {
  ADMIN: "admin",
  MANAGER: "manager",
  STAFF: "staff",
  SUPER_STAFF: "super-staff",
  USER: "user"
}, ve = {
  CAN_CREATE_FORMS: "can_create_forms",
  CAN_DOWNLOAD_FORMS: "can_download_forms",
  CAN_REVIEW_FORMS: "can_review_forms"
};
class Sn {
  constructor(e = {}) {
    this.staff = e.staff || !1, this.superUser = e.superUser || !1, this.trialContainerPermissions = [], this.type = le.USER;
  }
  setAccountPermissions(e) {
    e.admin ? this.type = le.ADMIN : e.manager ? this.type = le.MANAGER : this.type = le.USER;
  }
  setTrialContainerPermissions(e) {
    switch (this.type) {
      case le.ADMIN:
        this.trialContainerPermissions = Object.values(ve);
        break;
      case le.MANAGER:
        this.trialContainerPermissions = [];
        break;
      case le.USER:
        this.trialContainerPermissions = e;
        break;
      default:
        this.trialContainerPermissions = [];
    }
  }
}
class Ct {
  constructor(e = {}) {
    this.firstName = e.firstName, this.id = e.id, this.lastName = e.lastName, this.permissions = new Sn(e.permissions);
  }
  getFullName() {
    return !this.firstName && !this.lastName ? "Not set" : `${this.firstName} ${this.lastName}`;
  }
  getTrialContainerPermissions() {
    return this.permissions.trialContainerPermissions;
  }
  setAccountPermissions(e) {
    return this.permissions.setAccountPermissions(e), this;
  }
  setTrialContainerPermissions(e) {
    return this.permissions.setTrialContainerPermissions(e), this;
  }
}
class En {
  constructor(e = {}) {
    this.id = e.id, this.name = e.name;
  }
}
class _n {
  constructor(e = {}) {
    this.canAddComments = e.canAddComments, this.deletable = e.deletable, this.editable = e.editable;
  }
}
const re = {
  final: "final",
  "in-progress": "in-progress",
  initial: "initial",
  rejected: "rejected"
};
class bt {
  constructor(e = {}) {
    this.id = e.id, this.name = e.name, this.options = new _n(e.options), this.type = re[e.type];
  }
  attachForms(e) {
    this.forms = e;
  }
  isEditable() {
    return this.options.editable;
  }
  isReviewable() {
    return this.options.canAddComments;
  }
}
class An {
  constructor(e = {}) {
    this.skipValidation = e.skipValidation;
  }
}
class wt {
  constructor(e) {
    this.reason = e.reason, this.signatureType = e.signatureType;
  }
}
wt.propTypes = {
  reason: i.string,
  signatureType: i.string
};
class or {
  constructor(e = {}) {
    this.activityText = e.activityText, this.id = e.id, this.name = e.name, this.options = new An(e.options), this.requiresReasonForChange = e.requiresReasonForChange, this.requiresReviewComments = e.requiresReviewComments, this.requiresSignatures = e.requiresSignatures, this.signatureDefinitions = e.signatureDefinitions.map(
      (t) => new wt(t)
    );
  }
  requiresSignature() {
    return this.requiresSignatures.length > 0;
  }
  requiresAdditionalSteps() {
    return this.requiresReasonForChange || this.requiresSignature();
  }
}
let X = class ft {
  constructor(e = {}) {
    this.audience = e.audience ? e.audience.map((t) => new Ct(t)) : [], this.createdAt = e.createdAt && me(e.createdAt), this.description = e.description, this.fields = e.fields ? e.fields.map((t) => nr.create(t)) : [], this.hasComments = e.hasComments, this.hasHistory = e.hasHistory, this.history = e.history ? e.history.map((t) => new Rn(t)) : [], this.id = e.id, this.signatures = e.signatures ? e.signatures.map((t) => new ir(t)) : [], this.currentState = new bt(e.currentState), this.title = e.title, this.currentTransitions = e.currentTransitions ? e.currentTransitions.map((t) => new or(t)) : [], this.version = e.versionNumber, this.versions = e.versions ? e.versions.map((t) => new ft(t)) : [];
  }
  getFormattedTitle(e = !1) {
    const t = `${this.getFormattedVersion("v")} - ${$e(this.createdAt, ne.DATE_TIME)}`;
    return e ? `[${t}]` : t;
  }
  getFormattedSubtitle() {
    return `${this.isRejected() ? "Rejected " : ""}${this.id} [${this.getFormattedVersion("v")} - Created: ${$e(
      this.createdAt,
      ne.DATE_TIME
    )}]`;
  }
  getFormattedVersion(e = "") {
    return this.version === 0 ? "DRAFT" : `${e}${this.version}`;
  }
  hasAudience() {
    return !!this.audience.length;
  }
  isCompleted() {
    return this.isStateType(re.final);
  }
  isInitial() {
    return this.isStateType(re.initial);
  }
  isRejected() {
    return this.isStateType(re.rejected);
  }
  isEditable() {
    return this.currentState.isEditable();
  }
  isReviewable() {
    return this.currentState.isReviewable();
  }
  isPreviewable() {
    return !this.isEditable() && !this.isReviewable();
  }
  isStateType(e) {
    return e === this.currentState.type;
  }
  static fromWorkflowState(e = {}, t = {}) {
    return new ft({
      ...e,
      currentState: t
    });
  }
};
class Tt {
  constructor(e = {}) {
    this.id = e.id, this.name = e.name, this.type = e.type;
  }
}
const ko = {
  ASSET: "Asset",
  STUDY_PROCEDURE: "Study::Procedure"
};
class In {
  constructor(e = {}) {
    this.active = e.active, this.createdAt = e.createdAt && me(e.createdAt), this.description = e.description || void 0, this.id = e.id, this.title = e.title, this.workflowDefinition = new En({
      id: e.workflowDefinitionId,
      name: e.workflowDefinitionName
    });
  }
}
class vt {
  constructor(e = {}) {
    this.id = e.id, this.title = e.title, this.fields = e.fields ? e.fields.map((t) => nr.create(t)) : [];
  }
  withValues(e) {
    return this.fields = this.fields.map((t) => ({
      ...t,
      value: e[t.id]
    })), this;
  }
  notDefined() {
    return !this.id || !this.title || !this.fields.length;
  }
}
class On {
  constructor(e = {}) {
    this.id = e.id, this.timezone = e.timezone;
  }
}
const Nn = {
  LIBRARY: "Library",
  SITE: "Site"
};
class Dn {
  constructor(e = {}) {
    this.id = e.id, this.name = e.name, this.type = Nn[e.type.toUpperCase()];
  }
}
const sr = "SET_FORM_DATA", ar = "SET_FORMS_DATA", dr = "SET_FORM_CREATION_DATA", lr = "SET_FORM_TRANSITION_DATA", cr = "SET_FORM_HISTORY_DATA", ur = "SET_FORM_VERSIONS_DATA", mr = "SET_FORM_VERSION_DATA", pr = "SET_INTERNAL_SETTINGS", xn = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: !0
};
var Bt;
const it = (Bt = Jt.default) == null ? void 0 : Bt.create(xn);
class j {
  constructor() {
    this.abortControllers = /* @__PURE__ */ new Map();
  }
  abort(e) {
    var t;
    (t = this.abortControllers.get(e)) == null || t.abort();
  }
  register(e) {
    const t = new AbortController();
    return this.abortControllers.set(e, t), t;
  }
  static isAborted(e) {
    return Jt.isCancel(e);
  }
}
const Ge = {
  DELETE: "delete",
  GET: "get",
  POST: "post",
  PUT: "put"
}, ze = {
  fullResponse: !1
}, Vn = (r) => {
  var e, t;
  if ((t = (e = r.response) == null ? void 0 : e.config) != null && t.authenticityToken)
    try {
      G.post({
        data: {
          authenticityToken: r.response.config.authenticityToken,
          logMessage: r ? r.toString() : "Unknown error",
          logType: r.response.config.logType,
          requestType: r.response.config.method,
          url: r.response.config.url
        },
        url: `${r.response.config.baseApiUrl}/logs`
      });
    } catch {
    }
}, Q = (r, e, t) => ({
  authenticityToken: r,
  baseApiUrl: t,
  logType: Wr(e)
});
class G {
  static get({ customOptions: e = ze, data: t, options: s = {}, params: n, url: d }) {
    return this.request({
      customOptions: e,
      data: t,
      method: Ge.GET,
      options: s,
      params: n,
      url: d
    });
  }
  static post({ customOptions: e = ze, data: t, options: s = {}, params: n, url: d }) {
    return this.request({
      customOptions: e,
      data: t,
      method: Ge.POST,
      options: s,
      params: n,
      url: d
    });
  }
  static put({ customOptions: e = ze, data: t, options: s = {}, params: n, url: d }) {
    return this.request({
      customOptions: e,
      data: t,
      method: Ge.PUT,
      options: s,
      params: n,
      url: d
    });
  }
  static delete({ customOptions: e = ze, data: t, options: s = {}, params: n, url: d }) {
    return this.request({
      customOptions: e,
      data: t,
      method: Ge.DELETE,
      options: s,
      params: n,
      url: d
    });
  }
  static async request({ customOptions: e, data: t, method: s, options: n, params: d, url: o }) {
    it.interceptors.response.use(
      (l) => (l.data instanceof Blob || (l.data = je({ caseStyle: Dt.CAMEL_CASE, object: l.data })), l),
      (l) => {
        var c;
        return (c = l.response) != null && c.data ? Promise.reject({
          ...l,
          response: {
            ...l.response,
            data: je({ caseStyle: Dt.CAMEL_CASE, object: l.response.data })
          }
        }) : Promise.reject(l);
      }
    ), it.interceptors.request.use(
      (l) => (l.params = l.params && je({ object: l.params }), l.data = l.data && je({ object: l.data }), l),
      (l) => Promise.reject(l)
    );
    try {
      const l = await it({
        data: t,
        method: s,
        params: d,
        url: o,
        ...n
      });
      return e.fullResponse ? l : l.data;
    } catch (l) {
      return Vn(l), Promise.reject(l);
    }
  }
}
const Z = new j(), oe = ({ accountId: r, baseApiUrl: e, trialContainerId: t }) => `${e}/accounts/${r}/trial_containers/${t}`, U = (r) => {
  Z.abort(r);
}, Oe = ({
  accountId: r,
  authenticityToken: e,
  baseApiUrl: t,
  formContainerId: s,
  formContainerType: n,
  trialContainerId: d
}) => {
  U(Oe.name);
  const o = oe({ accountId: r, baseApiUrl: t, trialContainerId: d }), l = Z.register(Oe.name);
  return G.get({
    options: {
      signal: l.signal,
      ...Q(e, Oe.name, t)
    },
    params: {
      formContainerId: s,
      formContainerType: n
    },
    url: `${o}/forms`
  });
}, Ye = ({ accountId: r, authenticityToken: e, baseApiUrl: t, data: s, trialContainerId: n }) => {
  U(Ye.name);
  const d = oe({ accountId: r, baseApiUrl: t, trialContainerId: n }), o = Z.register(Ye.name);
  return G.post({
    data: {
      ...s,
      authenticityToken: e
    },
    options: {
      signal: o.signal,
      ...Q(e, Ye.name, t)
    },
    url: `${d}/forms`
  });
}, Ne = ({ accountId: r, authenticityToken: e, baseApiUrl: t, formId: s, trialContainerId: n }) => {
  U(Ne.name);
  const d = oe({ accountId: r, baseApiUrl: t, trialContainerId: n }), o = Z.register(Ne.name);
  return G.get({
    options: {
      signal: o.signal,
      ...Q(e, Ne.name, t)
    },
    url: `${d}/forms/${s}`
  });
}, Ke = ({
  accountId: r,
  authenticityToken: e,
  baseApiUrl: t,
  data: s,
  formId: n,
  transitionId: d,
  trialContainerId: o
}) => {
  U(Ke.name);
  const l = oe({ accountId: r, baseApiUrl: t, trialContainerId: o }), c = Z.register(Ke.name);
  return G.post({
    data: {
      ...s,
      authenticityToken: e
    },
    options: {
      signal: c.signal,
      ...Q(e, Ke.name, t)
    },
    url: `${l}/forms/${n}/transitions/${d}`
  });
}, De = ({ accountId: r, authenticityToken: e, baseApiUrl: t, formId: s, trialContainerId: n }) => {
  U(De.name);
  const d = oe({ accountId: r, baseApiUrl: t, trialContainerId: n }), o = Z.register(De.name);
  return G.get({
    options: {
      signal: o.signal,
      ...Q(e, De.name, t)
    },
    url: `${d}/forms/${s}/history`
  });
}, xe = ({ accountId: r, authenticityToken: e, baseApiUrl: t, formId: s, trialContainerId: n }) => {
  U(xe.name);
  const d = oe({ accountId: r, baseApiUrl: t, trialContainerId: n }), o = Z.register(xe.name);
  return G.get({
    options: {
      signal: o.signal,
      ...Q(e, xe.name, t)
    },
    url: `${d}/forms/${s}/versions`
  });
}, Ve = ({
  accountId: r,
  authenticityToken: e,
  baseApiUrl: t,
  formId: s,
  trialContainerId: n,
  versionNumber: d
}) => {
  U(Ve.name);
  const o = oe({ accountId: r, baseApiUrl: t, trialContainerId: n }), l = Z.register(Ve.name);
  return G.get({
    options: {
      signal: l.signal,
      ...Q(e, Ve.name, t)
    },
    url: `${o}/forms/${s}/versions/${d}`
  });
}, Je = ({ accountId: r, authenticityToken: e, baseApiUrl: t, formId: s, trialContainerId: n }) => {
  U(Je.name);
  const d = oe({ accountId: r, baseApiUrl: t, trialContainerId: n }), o = Z.register(Je.name);
  return G.get({
    customOptions: {
      fullResponse: !0
    },
    options: {
      responseType: "blob",
      signal: o.signal,
      ...Q(e, Je.name, t)
    },
    url: `${d}/forms/${s}/exports`
  });
}, hr = new j(), kn = ({ accountId: r, baseApiUrl: e, trialContainerId: t }) => `${e}/accounts/${r}/trial_containers/${t}`, fr = (r) => {
  hr.abort(r);
}, ke = ({ accountId: r, authenticityToken: e, baseApiUrl: t, formContainer: s, trialContainerId: n }) => {
  fr(ke.name);
  const d = kn({ accountId: r, baseApiUrl: t, trialContainerId: n }), o = hr.register(ke.name), l = new URLSearchParams({
    form_container_id: s == null ? void 0 : s.id,
    form_container_type: s == null ? void 0 : s.type
  });
  return G.get({
    options: {
      signal: o.signal,
      ...Q(e, ke.name, t)
    },
    url: `${d}/form_templates?${l.toString()}`
  });
}, ot = (r) => ({
  type: ar,
  value: r
}), Xe = (r) => ({
  type: sr,
  value: r
}), st = (r) => ({
  type: dr,
  value: r
}), at = (r) => ({
  type: lr,
  value: r
}), dt = (r) => ({
  type: cr,
  value: r
}), lt = (r) => ({
  type: ur,
  value: r
}), ct = (r) => ({
  type: mr,
  value: r
}), $n = (r) => async (e, t) => {
  const { account: s, baseApiUrl: n, trialContainer: d } = t().internalReducer.internal;
  e(ot({ data: void 0, error: null, loading: !0 }));
  try {
    const o = await Oe({
      accountId: s.id,
      baseApiUrl: n,
      formContainerId: r.id,
      formContainerType: r.type,
      trialContainerId: d.id
    });
    e(
      ot({
        data: o.map((l) => {
          const c = new bt(l);
          return c.attachForms(
            l.forms.map((u) => X.fromWorkflowState(u, c))
          ), c;
        }),
        error: null,
        loading: !1
      })
    );
  } catch (o) {
    if (j.isAborted(o)) return;
    e(ot({ data: void 0, error: o, loading: !1 }));
  }
}, Mn = (r) => async (e, t) => {
  const { account: s, baseApiUrl: n, trialContainer: d } = t().internalReducer.internal;
  e(Xe({ data: void 0, error: null, loading: !0 }));
  try {
    const o = await Ne({
      accountId: s.id,
      baseApiUrl: n,
      formId: r,
      trialContainerId: d.id
    });
    e(Xe({ data: new X(o), error: null, loading: !1 }));
  } catch (o) {
    if (j.isAborted(o)) return;
    e(Xe({ data: void 0, error: o, loading: !1 }));
  }
}, qn = ({ formContainer: r, formTemplateId: e, onError: t, onSuccess: s }) => async (n, d) => {
  const { account: o, authenticityToken: l, baseApiUrl: c, trialContainer: u } = d().internalReducer.internal;
  n(st({ error: null, loading: !0 }));
  try {
    const m = await Ye({
      accountId: o.id,
      authenticityToken: l,
      baseApiUrl: c,
      data: {
        formContainerId: r.id,
        formContainerType: r.type,
        formTemplateId: e
      },
      trialContainerId: u.id
    });
    n(st({ error: null, loading: !1 })), s(m);
  } catch (m) {
    if (j.isAborted(m)) return;
    n(st({ error: m, loading: !1 })), t(m);
  }
}, Ln = ({ formData: r, formId: e, onError: t, onSuccess: s, transitionId: n }) => async (d, o) => {
  const { account: l, authenticityToken: c, baseApiUrl: u, trialContainer: m } = o().internalReducer.internal;
  d(at({ error: null, loading: !0 }));
  try {
    const w = await Ke({
      accountId: l.id,
      authenticityToken: c,
      baseApiUrl: u,
      data: r,
      formId: e,
      transitionId: n,
      trialContainerId: m.id
    });
    d(Xe({ data: new X(w), error: null, loading: !1 })), d(at({ error: null, loading: !1 })), s();
  } catch (w) {
    if (j.isAborted(w)) return;
    d(at({ error: w, loading: !1 })), t(w);
  }
}, Un = (r) => async (e, t) => {
  const { account: s, baseApiUrl: n, trialContainer: d } = t().internalReducer.internal;
  e(dt({ data: void 0, error: null, loading: !0 }));
  try {
    const o = await De({
      accountId: s.id,
      baseApiUrl: n,
      formId: r,
      trialContainerId: d.id
    });
    e(dt({ data: new X(o), error: null, loading: !1 }));
  } catch (o) {
    if (j.isAborted(o)) return;
    e(dt({ data: void 0, error: o, loading: !1 }));
  }
}, Pn = (r) => async (e, t) => {
  const { account: s, baseApiUrl: n, trialContainer: d } = t().internalReducer.internal;
  e(lt({ data: void 0, error: null, loading: !0 }));
  try {
    const o = await xe({
      accountId: s.id,
      baseApiUrl: n,
      formId: r,
      trialContainerId: d.id
    });
    e(lt({ data: new X(o), error: null, loading: !1 }));
  } catch (o) {
    if (j.isAborted(o)) return;
    e(lt({ data: void 0, error: o, loading: !1 }));
  }
}, Bn = (r, e) => async (t, s) => {
  const { account: n, baseApiUrl: d, trialContainer: o } = s().internalReducer.internal;
  t(ct({ data: void 0, error: null, loading: !0 }));
  try {
    const l = await Ve({
      accountId: n.id,
      baseApiUrl: d,
      formId: r,
      trialContainerId: o.id,
      versionNumber: e
    });
    t(ct({ data: new X(l), error: null, loading: !1 }));
  } catch (l) {
    if (j.isAborted(l)) return;
    t(ct({ data: void 0, error: l, loading: !1 }));
  }
}, Wn = () => () => {
  U(Oe.name);
}, Hn = () => () => {
  U(Ne.name);
}, jn = () => () => {
  U(De.name);
}, Gn = () => () => {
  U(xe.name);
}, zn = () => () => {
  U(Ve.name);
}, Yn = (r) => ({
  type: pr,
  value: r
}), Kn = {
  form: {
    data: void 0,
    error: null,
    loading: !0
  },
  formCreation: {
    error: null,
    loading: !1
  },
  formHistory: {
    data: void 0,
    error: null,
    loading: !0
  },
  formTransition: {
    error: null,
    loading: !1
  },
  formVersion: {
    data: void 0,
    error: null,
    loading: !0
  },
  formVersions: {
    data: void 0,
    error: null,
    loading: !0
  },
  forms: {
    data: void 0,
    error: null,
    loading: !0
  }
};
function Jn(r = Kn, { type: e, value: t } = {}) {
  switch (e) {
    case ar:
      return { ...r, forms: t };
    case sr:
      return { ...r, form: t };
    case dr:
      return { ...r, formCreation: t };
    case lr:
      return { ...r, formTransition: t };
    case cr:
      return { ...r, formHistory: t };
    case ur:
      return { ...r, formVersions: t };
    case mr:
      return { ...r, formVersion: t };
    default:
      return r;
  }
}
const Xn = {
  internal: {}
};
function Qn(r = Xn, { type: e, value: t } = {}) {
  switch (e) {
    case pr:
      return { ...r, internal: t };
    default:
      return r;
  }
}
const Zn = cn({
  formReducer: Jn,
  internalReducer: Qn
}), ei = {}, ti = [hn], ri = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || pn, qt = un(Zn, ei, ri(mn(...ti)));
function gr(r) {
  const { getFieldError: e = E, getFieldValue: t = E, setFieldValue: s = E } = r;
  return /* @__PURE__ */ a(ni, {
    ...x("step-modal-step-reason-for-change"),
    children: /* @__PURE__ */ a(ii, {
      children: /* @__PURE__ */ a(be, {
        error: e("reasonForChange"),
        id: "reason-for-change",
        label: "Reason For Change",
        name: "reason-for-change",
        onChange: (n) => s("reasonForChange", n.target.value),
        required: !0,
        value: t("reasonForChange")
      })
    })
  });
}
const ni = p(Wt).withConfig({
  displayName: "ReasonForChangeStep__StyledModalBody",
  componentId: "sc-c679694e-0"
})([
  ".error{margin-top:0;}"
]), ii = p.div.withConfig({
  displayName: "ReasonForChangeStep__Fields",
  componentId: "sc-c679694e-1"
})([
  "display:flex;width:80%;"
]);
gr.propTypes = {
  getFieldError: i.func,
  getFieldValue: i.func,
  setFieldValue: i.func
};
function yr(r) {
  const { getFieldError: e = E, getFieldValue: t = E, modalRef: s = void 0, setFieldValue: n = E, signatureDefinitions: d = [] } = r, o = ue(() => d.map((u) => new ut(u.signatureType, u.signatureType)), [
    d
  ]), l = ue(() => {
    const u = d.find((m) => m.signatureType === t("signatureMeaning"));
    return u ? [
      new ut(u.reason, u.reason)
    ] : [];
  }, [
    d
  ]), { currentUser: c } = $((u) => u.internalReducer.internal);
  return /* @__PURE__ */ a(oi, {
    ...x("step-modal-step-signature"),
    children: /* @__PURE__ */ C(si, {
      children: [
        /* @__PURE__ */ C("div", {
          children: [
            /* @__PURE__ */ a(ai, {
              children: "Name"
            }),
            /* @__PURE__ */ a(di, {
              children: c.getFullName()
            })
          ]
        }),
        /* @__PURE__ */ C(li, {
          children: [
            /* @__PURE__ */ a(be, {
              error: e("signatureEmail"),
              id: "signature-email",
              label: "Email Address",
              name: "email-address",
              onChange: (u) => n("signatureEmail", u.target.value),
              required: !0,
              value: t("signatureEmail")
            }),
            /* @__PURE__ */ a(be, {
              error: e("signaturePassword"),
              id: "signature-password",
              label: "Password",
              name: "password",
              onChange: (u) => n("signaturePassword", u.target.value),
              required: !0,
              type: jr.PASSWORD,
              value: t("signaturePassword")
            }),
            /* @__PURE__ */ a(mt, {
              error: e("signatureMeaning"),
              id: "signature-meaning",
              label: "Signature Meaning",
              name: "signature-meaning",
              onChange: (u) => n("signatureMeaning", u.target.value),
              options: o,
              portals: {
                overlay: s.current
              },
              required: !0,
              value: t("signatureMeaning")
            }),
            /* @__PURE__ */ a(mt, {
              error: e("signatureReason"),
              id: "signature-reason",
              label: "Signature Reason",
              name: "signature-reason",
              onChange: (u) => n("signatureReason", u.target.value),
              options: l,
              portals: {
                overlay: s.current
              },
              required: !0,
              value: t("signatureReason")
            })
          ]
        })
      ]
    })
  });
}
const oi = p(Wt).withConfig({
  displayName: "SignatureStep__StyledModalBody",
  componentId: "sc-3713886f-0"
})([
  "display:flex;flex-direction:column;place-items:normal;padding-left:10%;padding-right:10%;.error{margin-top:0;}"
]), si = p.div.withConfig({
  displayName: "SignatureStep__ModalBodyContent",
  componentId: "sc-3713886f-1"
})([
  "display:flex;flex-direction:column;gap:",
  ";"
], y.large), ai = p.div.withConfig({
  displayName: "SignatureStep__Label",
  componentId: "sc-3713886f-2"
})([
  "font-weight:",
  ";color:",
  ";"
], Ze.bold, R.black.medium), di = p.div.withConfig({
  displayName: "SignatureStep__Value",
  componentId: "sc-3713886f-3"
})([
  "color:",
  ";"
], R.black.medium), li = p.form.withConfig({
  displayName: "SignatureStep__Fields",
  componentId: "sc-3713886f-4"
})([
  "display:grid;grid-template-columns:repeat(2,auto);grid-template-rows:repeat(2,auto);gap:",
  ";@media (width <= ",
  "){grid-template-columns:repeat(1,auto);}"
], y.medium, Hr.mobile);
yr.propTypes = {
  getFieldError: i.func,
  getFieldValue: i.func,
  modalRef: i.shape({
    current: i.oneOfType([
      i.shape({}),
      i.node
    ])
  }),
  setFieldValue: i.func,
  signatureDefinitions: i.arrayOf(i.shape(wt.propTypes))
};
const ci = {
  "form-transition": { confirm: "Confirm", cancel: "Cancel", next: "Next", sign: "Sign", back: "Back" }
}, ce = (r) => {
  let e = ci;
  return r.split(".").forEach((t) => {
    e = e[t] || `Property ${t} not found`;
  }), e;
};
function Fr(r) {
  const { formId: e, makeTransition: t = E, onClose: s = E, transition: n = void 0, visible: d = !1 } = r, o = {
    REASON_FOR_CHANGE: "reason-for-change",
    SIGNATURE: "signature"
  }, l = {
    SIGNATURE: "signature_params"
  }, c = ue(() => ({
    ...n != null && n.requiresReasonForChange ? {
      [o.REASON_FOR_CHANGE]: {
        reasonForChange: void 0
      }
    } : {},
    ...n != null && n.requiresSignature() ? {
      [o.SIGNATURE]: {
        signatureEmail: void 0,
        signatureMeaning: n.signatureDefinitions[0].signatureType,
        signaturePassword: void 0,
        signatureReason: n.signatureDefinitions[0].reason
      }
    } : {}
  }), [
    n
  ]), u = ue(() => {
    const v = /* @__PURE__ */ new Map();
    return n != null && n.requiresReasonForChange && v.set(o.REASON_FOR_CHANGE, [
      {
        id: `${o.REASON_FOR_CHANGE}.reasonForChange`,
        required: !0,
        value: c[o.REASON_FOR_CHANGE].reasonForChange
      }
    ]), n != null && n.requiresSignature() && v.set(o.SIGNATURE, [
      {
        id: `${o.SIGNATURE}.signatureEmail`,
        required: !0,
        value: c[o.SIGNATURE].signatureEmail
      },
      {
        id: `${o.SIGNATURE}.signaturePassword`,
        required: !0,
        value: c[o.SIGNATURE].signaturePassword
      },
      {
        id: `${o.SIGNATURE}.signatureMeaning`,
        required: !0,
        value: c[o.SIGNATURE].signatureMeaning
      },
      {
        id: `${o.SIGNATURE}.signatureReason`,
        required: !0,
        value: c[o.SIGNATURE].signatureReason
      }
    ]), v;
  }, [
    c,
    n
  ]), m = yt(), [w, b] = D(1), [h, f] = D(!1), g = ue(() => (n == null ? void 0 : n.requiresReasonForChange) && w === 1, [
    w,
    n
  ]), O = ue(() => (n == null ? void 0 : n.requiresSignature()) && !g, [
    g,
    n
  ]), _ = Qe({
    defaultValues: c
  }), { formState: ae, getValues: F, register: ee, reset: B, setError: z, setValue: N, trigger: M, watch: _e } = _, S = (v, A) => {
    var Y, ge;
    return (ge = (Y = ae.errors[v]) == null ? void 0 : Y[A]) == null ? void 0 : ge.message;
  }, de = (v, A) => _e(`${v}.${A}`), Pe = (v, A, Y) => N(`${v}.${A}`, Y), { validationMessages: tt } = Gr(), W = () => {
    s(), B();
  }, rt = () => {
    Array.from(u.values()).flat().forEach((v) => {
      ee(v.id, {
        required: {
          message: tt.required(),
          value: v.required
        },
        value: v.value
      });
    });
  }, nt = (v) => {
    const { transitionErrors: A } = v.response.data.error || {};
    A != null && A.length && A.forEach((Y) => {
      l.SIGNATURE === Y.property && [
        `${o.SIGNATURE}.signatureEmail`,
        `${o.SIGNATURE}.signaturePassword`
      ].forEach((ge) => z(ge, {
        message: Y.message
      }));
    }), f(!1);
  }, Be = (v) => {
    f(!0), t({
      ...v,
      onError: nt,
      onSuccess: () => {
        f(!1), b(1), W();
      },
      transition: n
    });
  }, Ae = kt(async () => await M(o.REASON_FOR_CHANGE) ? n.requiresSignature() ? !0 : Be({
    reasonForChange: F(o.REASON_FOR_CHANGE).reasonForChange
  }) : !1, [
    n
  ]), We = kt(async () => {
    if (!await M(o.SIGNATURE)) return !1;
    const A = F(o.SIGNATURE);
    return Be({
      ...n.requiresReasonForChange ? {
        reasonForChange: F(o.REASON_FOR_CHANGE).reasonForChange
      } : {},
      signature: {
        email: A.signatureEmail,
        password: A.signaturePassword,
        signatureType: A.signatureMeaning
      }
    });
  }, [
    n
  ]), He = ue(() => {
    const v = new zr();
    return n != null && n.requiresReasonForChange && v.addStep({
      modalName: "reason-for-change",
      modalTitle: "Provide a reason for changing this form",
      nextButton: {
        disabled: h,
        loading: h,
        onClick: () => Ae(),
        text: n.requiresSignature() ? ce("form-transition.next") : ce("form-transition.confirm")
      },
      previousButton: {
        disabled: h,
        onClick: W,
        text: ce("form-transition.cancel")
      }
    }), n != null && n.requiresSignature() && v.addStep({
      modalName: "signature",
      modalSubtitle: `Changing form ${e}`,
      modalTitle: "Add your signature",
      nextButton: {
        disabled: h,
        loading: h,
        onClick: () => We(),
        text: ce("form-transition.sign")
      },
      previousButton: {
        disabled: h,
        onClick: n.requiresReasonForChange ? E : W,
        text: n.requiresReasonForChange ? ce("form-transition.back") : ce("form-transition.cancel")
      }
    }), v.build();
  }, [
    ce,
    W,
    Ae,
    We,
    n,
    h
  ]);
  return V(() => {
    rt();
  }, [
    n,
    d
  ]), Object.keys(He).length === 0 ? null : /* @__PURE__ */ C(Yr, {
    ref: m,
    onClose: W,
    onStepChange: b,
    step: w,
    steps: He,
    visible: d,
    children: [
      g ? /* @__PURE__ */ a(gr, {
        getFieldError: (v) => S(o.REASON_FOR_CHANGE, v),
        getFieldValue: (v) => de(o.REASON_FOR_CHANGE, v),
        setFieldValue: (v, A) => Pe(o.REASON_FOR_CHANGE, v, A)
      }) : null,
      O ? /* @__PURE__ */ a(yr, {
        getFieldError: (v) => S(o.SIGNATURE, v),
        getFieldValue: (v) => de(o.SIGNATURE, v),
        modalRef: m,
        setFieldValue: (v, A) => Pe(o.SIGNATURE, v, A),
        signatureDefinitions: n.signatureDefinitions
      }) : null
    ]
  });
}
Fr.propTypes = {
  formId: i.number.isRequired,
  makeTransition: i.func,
  onClose: i.func,
  transition: i.instanceOf(or),
  visible: i.bool
};
const L = {
  ACTION: "action",
  BACK: "back"
};
function Cr(r) {
  const { buttons: e = [], loading: t = !1, ...s } = r, n = 2, d = () => e.filter((c) => L.ACTION === c.type).slice(0, n).map((c, u) => {
    const m = u === 0 ? Ce.PRIMARY : Ce.SECONDARY;
    return /* @__PURE__ */ a(gt, {
      content: c.disabled && c.tooltip ? c.tooltip : null,
      id: c.id,
      place: u === 0 ? pt.TOP_START : pt.TOP,
      children: /* @__PURE__ */ a(ht, {
        disabled: c.disabled,
        loading: c.loading,
        onClick: c.onClick,
        text: c.text,
        type: m
      })
    }, c.id);
  }), o = () => e.filter((c) => L.BACK === c.type).map((c) => /* @__PURE__ */ a(ht, {
    disabled: c.disabled,
    onClick: c.onClick,
    text: "Back",
    type: e.length === 1 ? Ce.PRIMARY : Ce.TERTIARY
  }, "back")), l = () => {
    const c = e.filter((u) => L.ACTION === u.type).slice(n, e.length).map((u) => new k({
      disabled: u.disabled,
      id: u.id,
      label: u.text,
      onClick: u.onClick,
      tooltip: u.tooltip
    }));
    return c.length ? /* @__PURE__ */ a(pi, {
      children: /* @__PURE__ */ a(Ht, {
        items: c,
        children: /* @__PURE__ */ a(jt, {
          icon: q.baselineMoreVert,
          size: Gt.SLIM,
          type: Ce.TERTIARY,
          ...x("footer-menu-button")
        })
      })
    }) : null;
  };
  return /* @__PURE__ */ C(ui, {
    ...s,
    children: [
      /* @__PURE__ */ C(mi, {
        children: [
          t && [
            ...Array(3).keys()
          ].map((c) => /* @__PURE__ */ a(Ie, {
            height: 40,
            width: 100
          }, c)),
          !t && /* @__PURE__ */ C(ie, {
            children: [
              d(),
              o()
            ]
          })
        ]
      }),
      !t && l()
    ]
  });
}
const ui = p.div.withConfig({
  displayName: "FormLayoutFooter__Footer",
  componentId: "sc-a5cb763e-0"
})([
  "display:flex;justify-content:space-between;gap:",
  ";"
], y.medium), mi = p.div.withConfig({
  displayName: "FormLayoutFooter__Buttons",
  componentId: "sc-a5cb763e-1"
})([
  "display:flex;flex-wrap:wrap;gap:",
  ";"
], y.medium), pi = p.div.withConfig({
  displayName: "FormLayoutFooter__DropdownButton",
  componentId: "sc-a5cb763e-2"
})([
  "display:flex;align-items:center;"
]);
Cr.propTypes = {
  buttons: i.arrayOf(i.shape({
    disabled: i.bool,
    id: i.string,
    loading: i.bool,
    onClick: i.func.isRequired,
    text: i.string,
    tooltip: i.string,
    type: i.oneOf(Object.values(L)).isRequired
  })),
  loading: i.bool
};
function fe(r) {
  const { buttons: e = [], children: t = null, header: s = null, loading: n = !1 } = r;
  return /* @__PURE__ */ C(hi, {
    children: [
      s,
      /* @__PURE__ */ C(fi, {
        children: [
          /* @__PURE__ */ a(J, {
            customStyles: {
              backgroundColor: R.grey.secondary
            }
          }),
          t,
          /* @__PURE__ */ a(J, {
            customStyles: {
              backgroundColor: R.grey.secondary
            }
          })
        ]
      }),
      /* @__PURE__ */ a(Cr, {
        buttons: e,
        loading: n
      })
    ]
  });
}
const hi = p.div.withConfig({
  displayName: "FormLayout__StyledFormLayout",
  componentId: "sc-4551bb3-0"
})([
  "display:grid;grid-template-rows:auto 1fr auto;gap:",
  ";padding:",
  ";overflow:hidden;height:100%;"
], y.medium, y.large), fi = p.div.withConfig({
  displayName: "FormLayout__FormContent",
  componentId: "sc-4551bb3-1"
})([
  "display:grid;grid-template-rows:auto 1fr auto;overflow:hidden;"
]);
fe.propTypes = {
  buttons: i.arrayOf(i.shape({
    disabled: i.bool,
    id: i.string,
    onClick: i.func.isRequired,
    text: i.string,
    type: i.oneOf(Object.values(L)).isRequired
  })),
  children: i.node,
  header: i.node,
  loading: i.bool
};
function Ue(r) {
  const { description: e = void 0, dropdownItems: t = [], loading: s = !1, rejected: n = !1, subtitle: d = void 0, title: o = void 0 } = r;
  return s ? /* @__PURE__ */ a(Lt, {
    children: /* @__PURE__ */ C(Ut, {
      className: "loading",
      children: [
        /* @__PURE__ */ a(Ie, {
          height: 18,
          width: 250
        }),
        /* @__PURE__ */ a(Ie, {
          height: 28,
          width: 300
        }),
        /* @__PURE__ */ a(Ie, {
          height: 14,
          width: 150
        })
      ]
    })
  }) : /* @__PURE__ */ C(Lt, {
    children: [
      /* @__PURE__ */ C(Ut, {
        children: [
          /* @__PURE__ */ a(yi, {
            className: Ft({
              rejected: n
            }),
            children: d
          }),
          /* @__PURE__ */ a(gi, {
            children: o
          }),
          /* @__PURE__ */ a(Fi, {
            children: e
          })
        ]
      }),
      !!t.length && /* @__PURE__ */ a(Ci, {
        children: /* @__PURE__ */ a(Ht, {
          items: t,
          children: /* @__PURE__ */ a(jt, {
            icon: q.baselineMoreVert,
            size: Gt.SLIM,
            type: Ce.TERTIARY,
            ...x("dropdown-button")
          })
        })
      })
    ]
  });
}
const Lt = p.div.withConfig({
  displayName: "FormLayoutHeader__StyledHeader",
  componentId: "sc-1acccc61-0"
})([
  "display:grid;grid-template-columns:1fr auto;column-gap:",
  ";"
], y.medium), Ut = p.div.withConfig({
  displayName: "FormLayoutHeader__HeaderValues",
  componentId: "sc-1acccc61-1"
})([
  "display:grid;grid-template-rows:repeat(3,auto);&.loading{row-gap:",
  ";}"
], y.xsmall), gi = p.div.withConfig({
  displayName: "FormLayoutHeader__Title",
  componentId: "sc-1acccc61-2"
})([
  "font-size:",
  ";font-weight:",
  ";"
], pe.mlarge, Ze.bold), yi = p.div.withConfig({
  displayName: "FormLayoutHeader__Subtitle",
  componentId: "sc-1acccc61-3"
})([
  "color:",
  ";font-size:",
  ";&.rejected{color:",
  ";}"
], R.grey.medium, pe.medium, R.red.primary), Fi = p.div.withConfig({
  displayName: "FormLayoutHeader__Description",
  componentId: "sc-1acccc61-4"
})([
  "font-size:",
  ";"
], pe.small), Ci = p.div.withConfig({
  displayName: "FormLayoutHeader__DropdownButton",
  componentId: "sc-1acccc61-5"
})([
  "display:flex;align-items:center;"
]);
Ue.propTypes = {
  description: i.string,
  dropdownItems: i.arrayOf(i.instanceOf(k)),
  loading: i.bool,
  rejected: i.bool,
  subtitle: i.string,
  title: i.string
};
function Rt(r) {
  const { formId: e, formVersion: t, signatures: s = [] } = r;
  return /* @__PURE__ */ C(bi, {
    children: [
      /* @__PURE__ */ a(wi, {
        children: "Signatures:"
      }),
      s.map((n) => /* @__PURE__ */ a(fn, {
        createdAt: $e(n.createdAt, ne.DATE_TIME),
        email: n.email,
        firstName: n.firstName,
        formId: e,
        formVersion: t,
        lastName: n.lastName,
        meaning: n.meaning,
        objectUuid: n.objectUuid,
        reason: n.reason,
        signatureUuid: n.id,
        userUuid: n.userUuid,
        verificationStatus: n.verificationStatus
      }, n.id))
    ]
  });
}
const bi = p.div.withConfig({
  displayName: "FormSignatures__SignaturesContainer",
  componentId: "sc-74abb8df-0"
})([
  "> div:not(:first-child):not(:last-child){border-bottom:1px solid ",
  ";}"
], R.grey.secondary), wi = p.div.withConfig({
  displayName: "FormSignatures__Header",
  componentId: "sc-74abb8df-1"
})([
  "color:",
  ";"
], R.grey.medium);
Rt.propTypes = {
  formId: i.string.isRequired,
  formVersion: i.string.isRequired,
  signatures: i.arrayOf(i.instanceOf(ir))
};
const se = p.div.withConfig({
  displayName: "ListWrapper",
  componentId: "sc-9b1b8a51-0"
})([
  "display:flex;flex-direction:column;gap:",
  ";"
], y.small);
function br(r) {
  const { dropdownHeight: e = 300, dropdownPositioning: t = {
    placement: "bottom-start"
  }, onApply: s, onFilterOptions: n, onToggle: d = E, options: o, selectedElementText: l = void 0, smallText: c = void 0, transformSelectedValues: u = (b) => b, values: m = [] } = r;
  return /* @__PURE__ */ a(gn, {
    dropdownHeight: e,
    dropdownPositioning: t,
    filterOptions: n,
    onApply: (b, h) => {
      s(b, u(h));
    },
    onToggle: d,
    options: o,
    savedOptionsChecked: m,
    selectedElementText: l,
    smallText: c
  });
}
br.propTypes = {
  dropdownHeight: i.number,
  dropdownPositioning: i.shape({
    placement: i.string
  }),
  onApply: i.func.isRequired,
  onFilterOptions: i.func.isRequired,
  onToggle: i.func,
  options: i.arrayOf(i.shape({
    id: i.number,
    optionText: i.string
  })).isRequired,
  selectedElementText: i.string,
  smallText: i.string,
  transformSelectedValues: i.func,
  values: i.arrayOf(i.number)
};
const Ti = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [
          0,
          xt(y.medium, document)
        ],
        resize: !0,
        scroll: !0
      }
    },
    {
      enabled: !0,
      fn: ({ state: r }) => {
        const e = Fn(r), t = r.placement === "top", s = e.top > 0 && e.top < 100, n = document.querySelector("#dropdown-wrapper-parent");
        if (n && t && s) {
          const { clientHeight: d } = n;
          n.style.height = `${d - e.top - xt(y.medium, document)}px`;
        }
      },
      name: "modifier",
      phase: "main",
      requiresIfExists: [
        "offset"
      ]
    }
  ],
  placement: "top"
};
function wr(r) {
  const { audience: e = [], onApply: t = E } = r;
  return /* @__PURE__ */ a(br, {
    dropdownPositioning: Ti,
    onApply: t,
    onFilterOptions: (d, o) => d.filter((l) => Fe(l.firstName).includes(Fe(o)) || Fe(l.lastName).includes(Fe(o)) || Fe(l.optionText).includes(Fe(o))),
    options: e.map((d) => ({
      ...d,
      optionText: d.getFullName()
    })),
    selectedElementText: "Select to notify",
    smallText: "Select one or more people to notify"
  });
}
wr.propTypes = {
  audience: i.arrayOf(i.instanceOf(Ct)),
  onApply: i.func
};
function Tr(r) {
  const { field: e, setValue: t = E, value: s = [] } = r, n = (o, l) => {
    let c = [
      ...s
    ];
    o.target.checked ? c.push(o.target.value) : c = c.filter((u) => u !== o.target.value), t(l, c);
  }, d = (o) => s ? s.includes(o) : !1;
  return /* @__PURE__ */ a(vi, {
    id: e.id,
    children: e.options.map((o) => /* @__PURE__ */ a(Kr, {
      checked: d(o),
      id: K(`${o}-option`),
      label: o,
      onChange: (l) => n(l, e.id),
      required: e.validations.required,
      value: o
    }, o))
  });
}
const vi = p.div.withConfig({
  displayName: "CheckboxFormFieldWrapper__CheckboxField",
  componentId: "sc-d37feb8a-0"
})([
  "display:flex;flex-wrap:wrap;gap:",
  ";"
], y.medium);
Tr.propTypes = {
  field: i.instanceOf(P).isRequired,
  setValue: i.func,
  value: i.arrayOf(i.string)
};
function St(r) {
  const { children: e = null, comments: t = [], message: s = void 0, messageVisible: n = !0 } = r, d = () => !!s && n;
  return t.length ? /* @__PURE__ */ C(Ri, {
    ...x("form-field-with-comment"),
    children: [
      /* @__PURE__ */ C(Si, {
        children: [
          /* @__PURE__ */ a(Ei, {
            ...x("comment-message"),
            children: t[0]
          }),
          /* @__PURE__ */ a(_i, {})
        ]
      }),
      /* @__PURE__ */ C(Ai, {
        children: [
          /* @__PURE__ */ a(Ii, {
            className: Ft({
              "with-border": n
            }),
            children: e
          }),
          d() && /* @__PURE__ */ a(Oi, {
            ...x("comment-error-message"),
            children: s
          })
        ]
      })
    ]
  }) : e;
}
const Ri = p.div.withConfig({
  displayName: "FormFieldCommentWrapper__StyledWrapper",
  componentId: "sc-62f2dc27-0"
})([
  "display:flex;flex-direction:column;gap:",
  ";"
], y.medium), Si = p.div.withConfig({
  displayName: "FormFieldCommentWrapper__CommentBox",
  componentId: "sc-62f2dc27-1"
})([
  "position:relative;padding:",
  ";background-color:",
  ";border-radius:",
  ";"
], y.medium, R.red.primaryAlpha10, y.xsmall), Ei = p.div.withConfig({
  displayName: "FormFieldCommentWrapper__Comment",
  componentId: "sc-62f2dc27-2"
})([
  "color:",
  ";text-overflow:ellipsis;overflow:hidden;"
], R.grey.medium), _i = p.div.withConfig({
  displayName: "FormFieldCommentWrapper__Arrow",
  componentId: "sc-62f2dc27-3"
})([
  "position:absolute;left:0;right:0;bottom:-",
  ";width:0;margin:auto;border:solid ",
  " transparent;border-top-color:",
  ";"
], y.slarge, y.lsmall, R.red.primaryAlpha10), Ai = p.div.withConfig({
  displayName: "FormFieldCommentWrapper__CommentWrapper",
  componentId: "sc-62f2dc27-4"
})([
  "display:flex;flex-direction:column;gap:",
  ";"
], y.xsmall), Ii = p.div.withConfig({
  displayName: "FormFieldCommentWrapper__CommentField",
  componentId: "sc-62f2dc27-5"
})([
  "&.with-border{border:1px solid ",
  ";border-radius:",
  ";}"
], R.red.primary, y.xsmall), Oi = p.div.withConfig({
  displayName: "FormFieldCommentWrapper__ErrorContainer",
  componentId: "sc-62f2dc27-6"
})([
  "font-size:",
  ";color:",
  ";"
], pe.small, R.red.primary);
St.propTypes = {
  children: i.node,
  comments: i.arrayOf(i.string),
  message: i.string,
  messageVisible: i.bool
};
function vr(r) {
  const { children: e, error: t = void 0 } = r;
  return t ? /* @__PURE__ */ C(Ni, {
    ...x("form-field-with-error"),
    children: [
      /* @__PURE__ */ a(Di, {
        children: e
      }),
      /* @__PURE__ */ a(xi, {
        ...x("form-field-error-message"),
        children: t.message
      })
    ]
  }) : e;
}
const Ni = p.div.withConfig({
  displayName: "FormFieldErrorWrapper__StyledWrapper",
  componentId: "sc-cede92a1-0"
})([
  "display:flex;flex-direction:column;gap:",
  ";"
], y.xsmall), Di = p.div.withConfig({
  displayName: "FormFieldErrorWrapper__ErrorField",
  componentId: "sc-cede92a1-1"
})([
  "border:1px solid ",
  ";border-radius:",
  ";"
], R.red.primary, y.xsmall), xi = p.div.withConfig({
  displayName: "FormFieldErrorWrapper__ErrorContainer",
  componentId: "sc-cede92a1-2"
})([
  "font-size:",
  ";color:",
  ";"
], pe.small, R.red.primary);
vr.propTypes = {
  children: i.node.isRequired,
  error: i.shape({
    message: i.string.isRequired
  })
};
function Et(r) {
  const { children: e, description: t = void 0, label: s, required: n = !1, withPadding: d = !0, ...o } = r;
  return /* @__PURE__ */ C(Vi, {
    className: Ft({
      padding: d
    }),
    ...o,
    children: [
      /* @__PURE__ */ C(ki, {
        children: [
          /* @__PURE__ */ a("span", {
            ...x("form-field-label"),
            children: /* @__PURE__ */ a(Jr, {
              capitalisation: !1,
              required: n,
              text: s
            })
          }),
          t && /* @__PURE__ */ a(gt, {
            content: t || null,
            id: Xr(),
            place: pt.LEFT,
            children: /* @__PURE__ */ a($i, {
              children: /* @__PURE__ */ a(Te, {
                color: R.grey.medium,
                icon: q.baselineHelp
              })
            })
          })
        ]
      }),
      e
    ]
  });
}
const Vi = p.div.withConfig({
  displayName: "FormFieldLabelWrapper__StyledWrapper",
  componentId: "sc-3cb10157-0"
})([
  "display:flex;flex-direction:column;gap:",
  ";&.padding{padding:",
  ";}"
], y.small, y.lsmall), ki = p.div.withConfig({
  displayName: "FormFieldLabelWrapper__LabelRow",
  componentId: "sc-3cb10157-1"
})([
  "display:flex;justify-content:space-between;gap:",
  ";"
], y.small), $i = p.div.withConfig({
  displayName: "FormFieldLabelWrapper__Description",
  componentId: "sc-3cb10157-2"
})([
  "height:fit-content;"
]);
Et.propTypes = {
  children: i.node.isRequired,
  description: i.string,
  label: i.string.isRequired,
  required: i.bool,
  withPadding: i.bool
};
function Rr(r) {
  const { field: e, setValue: t = E, value: s = "" } = r, [n, d] = D(e.otherOptionChecked || !!s && !e.options.includes(s));
  V(() => {
    e.otherEnabled && e.setOtherOptionChecked(n);
  }, [
    n
  ]);
  const o = (u) => {
    t(e.id, u.target.value, {
      shouldDirty: !0
    }), d(!1);
  }, l = () => {
    t(e.id, "", {
      shouldDirty: !0
    }), d(!0);
  }, c = (u) => {
    t(e.id, u.target.value, {
      shouldDirty: !0
    });
  };
  return /* @__PURE__ */ C(Mi, {
    id: e.id,
    children: [
      e.options.map((u) => /* @__PURE__ */ a(Vt, {
        checked: s === u && !n,
        id: K(`${e.title}-${u}-option`),
        label: u,
        name: K(`${e.title}-${u}-option`),
        onChange: (m) => o(m),
        required: e.validations.required,
        value: u
      }, u)),
      e.otherEnabled && /* @__PURE__ */ C(ie, {
        children: [
          /* @__PURE__ */ a(Vt, {
            checked: n,
            id: K(`${e.title}-other-option`),
            label: e.otherField,
            name: K(`${e.title}-other-option`),
            onChange: l,
            required: e.validations.required,
            value: e.otherField
          }),
          n && /* @__PURE__ */ a(be, {
            id: K(`${e.title}-other-option`),
            label: "Enter text here",
            name: K(`${e.title}-other-option`),
            onChange: c,
            required: !0,
            value: s
          })
        ]
      })
    ]
  });
}
const Mi = p.div.withConfig({
  displayName: "RadioFormFieldWrapper__RadioField",
  componentId: "sc-29c97935-0"
})([
  "display:flex;flex-wrap:wrap;gap:",
  ";"
], y.medium);
Rr.propTypes = {
  field: i.instanceOf(P).isRequired,
  setValue: i.func,
  value: i.string
};
function Sr(r) {
  const { error: e = void 0, field: t, scrollContainer: s = void 0, setFormValue: n = E, value: d = void 0 } = r, o = {
    id: t.id,
    name: t.title,
    onChange: (c) => n(t.id, c.target.value, {
      shouldDirty: !0
    }),
    required: t.validations.required,
    value: d
  }, l = () => {
    switch (!0) {
      case t instanceof Xt:
        return /* @__PURE__ */ a(Tr, {
          field: t,
          setValue: n,
          value: d
        });
      case t instanceof Qt:
        return /* @__PURE__ */ a(Zr, {
          ...o,
          closeOnScroll: (c) => c.target === s.current,
          maxDate: Me.NOT_FUTURE_DATE === t.validations.dateRestriction ? /* @__PURE__ */ new Date() : void 0,
          minDate: Me.NOT_PAST_DATE === t.validations.dateRestriction ? /* @__PURE__ */ new Date() : void 0
        });
      case t instanceof Zt:
        return /* @__PURE__ */ a(zt, {
          ...o
        });
      case t instanceof er:
        return /* @__PURE__ */ a(mt, {
          ...o,
          options: t.options.map((c) => new ut(c, c)),
          withBlankOption: !0
        });
      case t instanceof tr:
        return /* @__PURE__ */ a(Rr, {
          field: t,
          setValue: n,
          value: d
        });
      case t instanceof rr:
        return t.isFormatted() ? /* @__PURE__ */ a(Qr, {
          ...o,
          format: t.validations.inputFormat,
          limit: t.validations.characterLimit
        }) : /* @__PURE__ */ a(be, {
          ...o
        });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ a(St, {
    comments: t.comments,
    message: "This field requires attention",
    messageVisible: !e,
    children: /* @__PURE__ */ a(vr, {
      error: e,
      children: /* @__PURE__ */ a(Et, {
        description: t.inputGuidance,
        label: t.title,
        required: t.validations.required,
        children: l()
      })
    })
  });
}
Sr.propTypes = {
  error: i.shape({
    message: i.string
  }),
  field: i.instanceOf(P).isRequired,
  scrollContainer: i.shape({
    current: i.shape({})
  }),
  setFormValue: i.func,
  value: i.oneOfType([
    i.string,
    i.arrayOf(i.string)
  ])
};
function _t(r) {
  const { field: e } = r, t = "---", s = () => Array.isArray(e.value) ? e.value.length ? e.value : [
    t
  ] : e.otherEnabled && e.value && !e.options.includes(e.value) ? [
    `${e.otherField ?? "Other"}: ${e.value}`
  ] : te.DATE === e.type ? [
    e.value && $e(me(e.value, ne.ISO_DATE), ne.DATE) || t
  ] : [
    e.value.trim() || t
  ];
  return /* @__PURE__ */ a(St, {
    comments: e.comments,
    ...x("form-field-with-comment"),
    children: /* @__PURE__ */ a(Et, {
      label: e.title,
      ...x("form-preview-field"),
      children: /* @__PURE__ */ a(qi, {
        ...x("form-preview-field-value"),
        children: s().map((n) => /* @__PURE__ */ a(Li, {
          children: n
        }, n))
      })
    })
  });
}
const qi = p.div.withConfig({
  displayName: "FormFieldPreviewWrapper__FieldValues",
  componentId: "sc-8e83a632-0"
})([
  "display:flex;flex-wrap:wrap;gap:",
  ";"
], y.small), Li = p.div.withConfig({
  displayName: "FormFieldPreviewWrapper__FieldValue",
  componentId: "sc-8e83a632-1"
})([
  "padding:",
  " ",
  ";background-color:",
  ";border-radius:",
  ";"
], y.small, y.medium, R.grey.secondary, y.xsmall);
_t.propTypes = {
  field: i.instanceOf(P).isRequired
};
function Er(r) {
  const { error: e = void 0, field: t, registerCommentField: s = E, setCommentValue: n = E, unregisterCommentField: d = E, watchCommentField: o = E } = r, l = "0", c = 200, u = Cn, [m, w] = D(!1), [b, h] = D(), [f, g] = D(!1), [O, _] = D(l), [ae, { height: F }] = Tn(), ee = wn({
    config: {
      DEFAULT_DURATION: c,
      DEFAULT_EASING: u
    },
    height: m ? `${O}px` : l,
    opacity: m ? 1 : 0
  });
  V(() => (_(F), window.addEventListener("resize", _(F)), window.removeEventListener("resize", _(F))), [
    F
  ]), V(() => {
    if (b && (clearTimeout(b), h()), !m && f) {
      const N = setTimeout(() => {
        g(!1);
      }, c);
      h(N);
    } else m && g(!0);
  }, [
    m
  ]);
  const B = () => {
    if (o(t.id)) return;
    const N = !m;
    w(N), N ? (s(t.id, {
      maxLength: {
        message: "Comment must not exceed 140 characters",
        value: 140
      },
      required: {
        message: "Comment cannot be left blank",
        value: !0
      },
      value: ""
    }), n(t.id, "")) : d(t.id);
  }, z = () => m ? R.red.primary : R.grey.medium;
  return /* @__PURE__ */ C(Ui, {
    ...x("form-field-with-review"),
    children: [
      /* @__PURE__ */ C(Pi, {
        children: [
          /* @__PURE__ */ a(Bi, {
            onClick: B,
            ...x("form-field-review-icon"),
            children: /* @__PURE__ */ a(Te, {
              color: z(),
              height: 24,
              icon: q.outlineFlag,
              width: 24
            })
          }),
          /* @__PURE__ */ a(_t, {
            field: t
          })
        ]
      }),
      /* @__PURE__ */ a(Wi, {
        style: ee,
        children: f ? /* @__PURE__ */ a(Hi, {
          ref: ae,
          children: /* @__PURE__ */ a(zt, {
            error: e,
            id: t.id,
            label: "Changes requested",
            name: "Changes requested",
            onChange: (N) => n(t.id, N.target.value, {
              shouldDirty: !0
            }),
            required: !0,
            value: o(t.id)
          })
        }) : null
      })
    ]
  });
}
const Ui = p.div.withConfig({
  displayName: "FormFieldReviewWrapper__StyledWrapper",
  componentId: "sc-9cad390b-0"
})([
  "display:flex;flex-direction:column;"
]), Pi = p.div.withConfig({
  displayName: "FormFieldReviewWrapper__StyledElement",
  componentId: "sc-9cad390b-1"
})([
  "display:grid;grid-template-columns:auto 1fr;"
]), Bi = p.div.withConfig({
  displayName: "FormFieldReviewWrapper__IconWrapper",
  componentId: "sc-9cad390b-2"
})([
  "padding-top:",
  ";cursor:pointer;"
], y.lsmall), Wi = p(bn.div).withConfig({
  displayName: "FormFieldReviewWrapper__ReviewWrapper",
  componentId: "sc-9cad390b-3"
})([
  ""
]), Hi = p.div.withConfig({
  displayName: "FormFieldReviewWrapper__CommentWrapper",
  componentId: "sc-9cad390b-4"
})([
  ""
]);
Er.propTypes = {
  error: i.string,
  field: i.instanceOf(P).isRequired,
  registerCommentField: i.func,
  setCommentValue: i.func,
  unregisterCommentField: i.func,
  watchCommentField: i.func
};
function At() {
  return /* @__PURE__ */ a(ji, {
    children: [
      ...Array(4).keys()
    ].map((e, t) => /* @__PURE__ */ C(Re.Fragment, {
      children: [
        /* @__PURE__ */ C(Ie, {
          height: 74,
          maxWidth: "100%",
          viewBox: "none",
          children: [
            /* @__PURE__ */ a("rect", {
              height: "18",
              rx: y.xsmall,
              ry: y.xsmall,
              width: "200",
              x: "0",
              y: "0"
            }),
            /* @__PURE__ */ a("rect", {
              height: "48",
              rx: y.xsmall,
              ry: y.xsmall,
              width: "100%",
              x: "0",
              y: "26"
            })
          ]
        }),
        t < 3 && /* @__PURE__ */ a(J, {
          customStyles: {
            backgroundColor: R.grey.secondary
          }
        })
      ]
    }, e))
  });
}
const ji = p(se).withConfig({
  displayName: "FormFieldsLoading__StyledLoader",
  componentId: "sc-2e417c0e-0"
})([
  "gap:",
  ";padding:",
  " 0;overflow:auto;svg{overflow:visible;}"
], y.medium, y.medium);
function It(r) {
  const { form: e, formMethods: t, scrollContainer: s = void 0 } = r, [n, d] = D(!1), { formState: { errors: o }, register: l, setValue: c, unregister: u, watch: m } = t;
  return V(() => ((() => {
    e.fields.forEach((b) => l(b.id, {
      required: {
        message: "This is a required field",
        value: b.validations.required
      },
      validate: (h) => b.validate(h),
      value: b.value
    })), d(!0);
  })(), () => u(e.fields.map((b) => b.id))), [
    e,
    l,
    u
  ]), n && e.fields.map((w, b) => /* @__PURE__ */ C(Re.Fragment, {
    children: [
      /* @__PURE__ */ a(Sr, {
        error: o[w.id],
        field: w,
        scrollContainer: s,
        setFormValue: c,
        value: m(w.id)
      }),
      b < e.fields.length - 1 && /* @__PURE__ */ a(J, {
        customStyles: {
          backgroundColor: R.grey.secondary
        }
      })
    ]
  }, w.id));
}
It.propTypes = {
  form: i.oneOfType([
    i.instanceOf(X),
    i.instanceOf(vt)
  ]).isRequired,
  formMethods: i.shape({
    formState: i.shape({
      errors: i.shape({
        message: i.string
      })
    }),
    register: i.func,
    setValue: i.func,
    watch: i.func
  }).isRequired,
  scrollContainer: i.shape({
    current: i.shape({})
  })
};
function qe(r) {
  const { form: e } = r;
  return e.fields.map((t, s) => /* @__PURE__ */ C(Re.Fragment, {
    children: [
      /* @__PURE__ */ a(_t, {
        field: t
      }),
      s < e.fields.length - 1 && /* @__PURE__ */ a(J, {
        customStyles: {
          backgroundColor: R.grey.secondary
        }
      })
    ]
  }, t.id));
}
qe.propTypes = {
  form: i.oneOfType([
    i.instanceOf(X),
    i.instanceOf(vt)
  ]).isRequired
};
function _r(r) {
  const { form: e, formMethods: t } = r, { formState: { errors: s }, register: n, setValue: d, unregister: o, watch: l } = t;
  return e.fields.map((c, u) => {
    var m;
    return /* @__PURE__ */ C(Re.Fragment, {
      children: [
        /* @__PURE__ */ a(Er, {
          error: (m = s[c.id]) == null ? void 0 : m.message,
          field: c,
          registerCommentField: n,
          setCommentValue: d,
          unregisterCommentField: o,
          watchCommentField: l
        }),
        u < e.fields.length - 1 && /* @__PURE__ */ a(J, {
          customStyles: {
            backgroundColor: R.grey.secondary
          }
        })
      ]
    }, c.id);
  });
}
_r.propTypes = {
  form: i.instanceOf(X).isRequired,
  formMethods: i.shape({
    formState: i.shape({
      errors: i.shape({
        message: i.string
      })
    }),
    register: i.func,
    setValue: i.func,
    unregister: i.func,
    watch: i.func
  }).isRequired
};
function Ar(r) {
  const { headerText: e, navigationBlocked: t = !1, warningText: s } = r, [n, d] = D(!1), [o, l] = D(!1), [c, u] = D(), m = he(), w = (g) => {
    g.preventDefault(), g.returnValue = "";
  };
  return V(() => (t ? window.onbeforeunload = w : window.onbeforeunload = null, () => {
    window.onbeforeunload = null;
  }), [
    t
  ]), V(() => {
    o && c && m.push(c.pathname);
  }, [
    m,
    o,
    c
  ]), /* @__PURE__ */ C(ie, {
    children: [
      /* @__PURE__ */ a(dn, {
        message: (g) => !o && t ? (d(!0), u(g), !1) : !0,
        when: t
      }),
      /* @__PURE__ */ a(en, {
        onClose: () => {
          d(!1);
        },
        onConfirm: () => {
          d(!1), l(!0);
        },
        text: s,
        title: e,
        visible: n
      })
    ]
  });
}
Ar.propTypes = {
  headerText: i.string.isRequired,
  navigationBlocked: i.bool,
  warningText: i.string.isRequired
};
function Gi() {
  return { downloadFile: (e, t) => {
    const s = document.createElement("a");
    s.href = URL.createObjectURL(e), s.download = t, document.body.appendChild(s), s.click(), document.body.removeChild(s);
  } };
}
const zi = () => {
  const [r, e] = D(!0), [t, s] = D([]), { account: n, baseApiUrl: d, formContainer: o, trialContainer: l } = $((c) => c.internalReducer.internal);
  return V(() => ((async () => {
    if (n != null && n.id)
      try {
        e(!0);
        const u = await ke({
          accountId: n == null ? void 0 : n.id,
          baseApiUrl: d,
          formContainer: o,
          trialContainerId: l == null ? void 0 : l.id
        });
        s(u.map((m) => new In(m))), e(!1);
      } catch (u) {
        if (j.isAborted(u)) return;
        e(!1);
      }
  })(), () => fr(ke.name)), [n, d, o, l]), { formTemplates: t, loading: r };
}, H = {
  DOWNLOAD_FORM_PDF: new k({
    disabled: !1,
    id: "download-form-pdf",
    label: "Download form (PDF)",
    onClick: E,
    tooltip: "You do not have permission to download forms"
  }),
  VIEW_FORM: new k({
    disabled: !1,
    id: "view-form",
    label: "View form",
    onClick: E,
    tooltip: void 0
  }),
  VIEW_FORM_HISTORY: new k({
    disabled: !1,
    id: "view-form-history",
    label: "View form history",
    onClick: E,
    tooltip: "Available once a form is submitted"
  }),
  VIEW_FORM_VERSIONS: new k({
    disabled: !1,
    id: "view-form-versions",
    label: "View form versions",
    onClick: E,
    tooltip: "Available once a form is submitted"
  })
};
function Yi() {
  const r = yt(), [e, t] = D([]), [s, n] = D(), [d, o] = D(!1), l = he(), { id: c } = et(), { url: u } = Ee(), m = Se(), { account: w, baseApiUrl: b, currentUser: h, disabled: f, onFormTransitionEnd: g, onNavigationBlockedChange: O, tooltip: _, trialContainer: ae } = $((T) => T.internalReducer.internal), { data: F, error: ee, loading: B } = $((T) => T.formReducer.form), { loading: z } = $((T) => T.formReducer.formTransition), N = Qe(), M = Qe(), { downloadFile: _e } = Gi(), { mounted: S } = Le({
    requiredValues: [
      w
    ]
  }), { showErrorToast: de, showSuccessToast: Pe } = Yt();
  V(() => (S && m(Mn(c)), () => {
    m(Hn());
  }), [
    S,
    c,
    m
  ]);
  const tt = (T, I) => {
    t(I);
  }, W = () => h == null ? void 0 : h.getTrialContainerPermissions().includes(ve.CAN_REVIEW_FORMS), rt = async (T) => F.isEditable() && T.options.skipValidation ? [
    !0
  ] : F.isEditable() ? [
    await N.trigger(),
    N.formState.errors
  ] : W() && F.isReviewable() ? [
    await M.trigger(),
    M.formState.errors
  ] : [
    !0
  ], nt = () => F.isEditable() ? Object.entries(N.getValues()).map(([T, I]) => ({
    fieldId: T,
    value: I
  })) : F.fields.map((T) => ({
    fieldId: T.id,
    value: T.value
  })), Be = () => Object.entries(M.getValues()).map(([T, I]) => ({
    comment: I,
    fieldId: T
  })), Ae = (T) => F.isEditable() ? z : W() && F.isReviewable() ? T.requiresReviewComments && !Object.values(M.getValues()).length : !1, We = (T) => !d && (s == null ? void 0 : s.id) === T.id && z, He = (T) => {
    const I = Object.values(T);
    I.length && document.getElementById(I[0].ref.name).scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }, v = (T) => {
    var I, ye;
    return (ye = (I = T.response.data.error) == null ? void 0 : I.transitionErrors) != null && ye[0] ? de(T.response.data.error.transitionErrors[0]) : T.response.data.error ? de({
      message: T.response.data.error
    }) : de(T.response.data);
  }, A = ({ onError: T = E, onSuccess: I = E, reasonForChange: ye, signature: qr, transition: Ot }) => {
    f || m(Ln({
      formData: {
        audience: e,
        formData: nt(),
        reasonForChange: ye,
        reviewData: Be(),
        signature: qr
      },
      formId: c,
      onError: (Nt) => {
        v(Nt), T(Nt);
      },
      onSuccess: () => {
        Pe(Ot.activityText), N.reset(void 0, {
          keepValues: !0
        }), M.reset(void 0, {
          keepValues: !0
        }), I();
      },
      transitionId: Ot.id
    }));
  }, Y = async (T) => {
    if (f || Ae(T)) return;
    const [I, ye] = await rt(T);
    if (!I) {
      He(ye);
      return;
    }
    if (n(T), T.requiresAdditionalSteps()) {
      o(!0);
      return;
    }
    A({
      onSuccess: g,
      transition: T
    });
  }, ge = async () => {
    try {
      const T = await Je({
        accountId: w.id,
        baseApiUrl: b,
        formId: c,
        trialContainerId: ae.id
      });
      _e(T.data, T.headers.filename);
    } catch {
      de({
        message: "Form PDF cannot be downloaded"
      });
    }
  }, Vr = () => {
    const T = F.currentTransitions.map((I) => ({
      disabled: Ae(I) || f,
      id: I.id,
      loading: We(I),
      onClick: () => Y(I),
      text: I.name,
      tooltip: _,
      type: L.ACTION
    }));
    return T.push({
      disabled: z,
      onClick: () => {
        l.push(u.replace(`/forms/${c}`, "/forms"));
      },
      type: L.BACK
    }), T;
  };
  V(() => {
    O && O(N.formState.isDirty || M.formState.isDirty);
  }, [
    O,
    N.formState.isDirty,
    M.formState.isDirty
  ]);
  const kr = () => [
    new k({
      ...H.VIEW_FORM_VERSIONS,
      disabled: !F.version,
      onClick: () => l.push(`${u}/versions`)
    }),
    new k({
      ...H.VIEW_FORM_HISTORY,
      disabled: !F.hasHistory,
      onClick: () => l.push(`${u}/history`)
    }),
    new k({
      ...H.DOWNLOAD_FORM_PDF,
      disabled: !h.getTrialContainerPermissions().includes(ve.CAN_DOWNLOAD_FORMS),
      onClick: ge
    })
  ], $r = () => /* @__PURE__ */ a(Ue, {
    description: F == null ? void 0 : F.description,
    dropdownItems: F && kr(),
    loading: B,
    rejected: F == null ? void 0 : F.isRejected(),
    subtitle: F && F.getFormattedSubtitle(),
    title: F == null ? void 0 : F.title
  }), Mr = () => f ? /* @__PURE__ */ a(qe, {
    form: F
  }) : F.isEditable() ? /* @__PURE__ */ a(It, {
    form: F,
    formMethods: N,
    scrollContainer: r
  }) : W() && F.isReviewable() ? /* @__PURE__ */ a(_r, {
    form: F,
    formMethods: M
  }) : !W() || F.isPreviewable() ? /* @__PURE__ */ a(qe, {
    form: F
  }) : null;
  return ee ? `Error: ${JSON.stringify(ee, null, 2)}` : /* @__PURE__ */ C(ie, {
    children: [
      /* @__PURE__ */ a(Ar, {
        headerText: "You have unsaved changes",
        navigationBlocked: N.formState.isDirty || M.formState.isDirty,
        warningText: "You are about to discard all the data you have entered. This action is irreversible."
      }),
      !!F && /* @__PURE__ */ a(Fr, {
        formId: F.id,
        makeTransition: A,
        onClose: () => {
          o(!1), n();
        },
        transition: s,
        visible: d
      }),
      /* @__PURE__ */ C(fe, {
        buttons: F && Vr(),
        header: $r(),
        loading: B,
        children: [
          B && /* @__PURE__ */ a(At, {}),
          !B && /* @__PURE__ */ C(Ki, {
            ref: r,
            children: [
              Mr(),
              F.hasAudience() && F.isInitial() && !f && /* @__PURE__ */ C(ie, {
                children: [
                  /* @__PURE__ */ a(J, {
                    customStyles: {
                      backgroundColor: R.grey.secondary
                    }
                  }),
                  /* @__PURE__ */ a(wr, {
                    audience: F.audience,
                    onApply: tt
                  })
                ]
              }),
              !!F.signatures.length && /* @__PURE__ */ a(Rt, {
                formId: `${F.id}`,
                formVersion: `${F.version}`,
                signatures: F.signatures
              })
            ]
          })
        ]
      })
    ]
  });
}
const Ki = p(se).withConfig({
  displayName: "Form__FormFields",
  componentId: "sc-91d3584a-0"
})([
  "gap:",
  ";padding:",
  " 0;overflow:auto;"
], y.medium, y.medium);
function Ir(r) {
  const { canAddForm: e = !1, disabled: t = !1, formContainerName: s, onAddForm: n, tooltip: d = void 0 } = r;
  return /* @__PURE__ */ a(Ji, {
    children: /* @__PURE__ */ C(Xi, {
      children: [
        /* @__PURE__ */ C(Qi, {
          children: [
            "This ",
            s,
            " currently has no forms."
          ]
        }),
        e && /* @__PURE__ */ a(gt, {
          content: t && d ? d : null,
          id: "empty-form-list-add-form",
          children: /* @__PURE__ */ a(ht, {
            disabled: t,
            onClick: n,
            text: "Add Form"
          })
        })
      ]
    })
  });
}
const Ji = p.div.withConfig({
  displayName: "EmptyFormList__Content",
  componentId: "sc-3e44bdf5-0"
})([
  "display:grid;place-items:center;height:100%;"
]), Xi = p.div.withConfig({
  displayName: "EmptyFormList__FormEmptyContent",
  componentId: "sc-3e44bdf5-1"
})([
  "display:flex;flex-direction:column;align-items:center;gap:",
  ";padding:",
  ";"
], y.medium, y.medium), Qi = p.div.withConfig({
  displayName: "EmptyFormList__Title",
  componentId: "sc-3e44bdf5-2"
})([
  "text-align:center;"
]);
Ir.propTypes = {
  canAddForm: i.bool,
  disabled: i.bool,
  formContainerName: i.string.isRequired,
  onAddForm: i.func.isRequired,
  tooltip: i.string
};
function Or(r) {
  const { canAddForm: e = !1, disabled: t = !1, loading: s = !1, onAddForm: n, onSelectForm: d, tooltip: o = "", workflowStates: l = [] } = r, c = (f) => {
    let g = null;
    const O = {
      COMMENTS: {
        color: R.red.primary,
        icon: q.baselineFlag,
        id: "comments-icon"
      },
      COMPLETED: {
        color: R.black.medium,
        icon: q.outlineCheck,
        id: "completed-icon"
      },
      EDITABLE: {
        color: R.black.medium,
        icon: q.baselineEdit,
        id: "editable-icon"
      },
      REJECTED: {
        color: R.red.primary,
        icon: q.baselineWarning,
        id: "rejected-icon"
      },
      REVIEWABLE: {
        color: R.black.medium,
        icon: q.baselinePeopleAlt,
        id: "reviewable-icon"
      }
    };
    return f.isReviewable() && (g = O.REVIEWABLE), f.isEditable() && (g = O.EDITABLE), f.isEditable() && f.hasComments && (g = O.COMMENTS), f.isRejected() && (g = O.REJECTED), f.isCompleted() && (g = O.COMPLETED), g && /* @__PURE__ */ a(Te, {
      color: g.color,
      height: 24,
      icon: g.icon,
      width: 24,
      ...x(g.id)
    });
  }, u = (f) => /* @__PURE__ */ C("div", {
    ...x(K(`${f.name}-accordion`)),
    children: [
      f.name,
      " (",
      f.forms.length,
      ")"
    ]
  }), m = (f) => {
    const g = [
      `${f.id}`,
      f.getFormattedTitle(!0)
    ];
    return f.isRejected() && g.unshift("Rejected"), g;
  }, w = (f) => {
    if (!f.forms.length) {
      const g = {
        [re.initial]: "No forms pending",
        [re["in-progress"]]: "No forms pending",
        [re.final]: "No forms completed",
        [re.rejected]: "No forms rejected"
      };
      return /* @__PURE__ */ a(Pt, {
        children: /* @__PURE__ */ a(we, {
          disabled: !0,
          children: g[f.type]
        })
      });
    }
    return /* @__PURE__ */ a(Pt, {
      ...x(K(`${f.name}-cards`)),
      children: f.forms.map((g) => /* @__PURE__ */ a(Kt, {
        descriptionType: g.isRejected() ? tn.ERROR : void 0,
        details: m(g),
        icon: /* @__PURE__ */ a(Te, {
          height: 24,
          icon: q.outlineInventory,
          width: 24
        }),
        onClick: () => d(g),
        title: g.title,
        children: c(g)
      }, g.id))
    });
  }, b = () => {
    t || n();
  };
  return /* @__PURE__ */ a(fe, {
    buttons: e ? [
      {
        disabled: t,
        id: "add-form",
        onClick: b,
        text: "Add Form",
        tooltip: o,
        type: L.ACTION
      }
    ] : [],
    header: /* @__PURE__ */ a(Zi, {
      children: "Forms"
    }),
    loading: s,
    children: /* @__PURE__ */ C(eo, {
      children: [
        s && [
          ...Array(4).keys()
        ].map((f) => /* @__PURE__ */ a(we, {
          loading: s
        }, f)),
        !s && l.map((f, g) => /* @__PURE__ */ C(Re.Fragment, {
          children: [
            /* @__PURE__ */ a(yn, {
              content: w(f),
              id: f.name,
              item: u(f)
            }),
            g !== l.length - 1 && /* @__PURE__ */ a(J, {
              customStyles: {
                backgroundColor: R.grey.secondary
              }
            })
          ]
        }, f.type))
      ]
    })
  });
}
const Zi = p.div.withConfig({
  displayName: "FormList__Title",
  componentId: "sc-ff2aa95-0"
})([
  "font-size:",
  ";font-weight:",
  ";"
], pe.large, Ze.bold), eo = p(se).withConfig({
  displayName: "FormList__Content",
  componentId: "sc-ff2aa95-1"
})([
  "padding-top:",
  ";padding-bottom:",
  ";overflow:auto;"
], y.medium, y.medium), Pt = p(se).withConfig({
  displayName: "FormList__Cards",
  componentId: "sc-ff2aa95-2"
})([
  "padding-top:",
  ";"
], y.medium);
Or.propTypes = {
  canAddForm: i.bool,
  disabled: i.bool,
  loading: i.bool,
  onAddForm: i.func.isRequired,
  onSelectForm: i.func.isRequired,
  tooltip: i.string,
  workflowStates: i.arrayOf(i.instanceOf(bt))
};
function Nr(r) {
  const { formContainer: e } = r, [t, s] = D(!1), n = he(), { url: d } = Ee(), o = Se(), { account: l, currentUser: c, disabled: u, tooltip: m } = $((_) => _.internalReducer.internal), { data: w, loading: b } = $((_) => _.formReducer.forms), { mounted: h } = Le({
    requiredValues: [
      l,
      e
    ]
  });
  V(() => (h && o($n(e)), () => o(Wn())), [
    h,
    e.id,
    e.name,
    e.type,
    o
  ]), V(() => {
    w && s(!!w.flatMap((_) => _.forms).length);
  }, [
    w
  ]);
  const f = () => {
    n.push(`${d}/templates`);
  }, g = (_) => {
    n.push(`${d}/${_.id}`);
  }, O = () => c == null ? void 0 : c.getTrialContainerPermissions().includes(ve.CAN_CREATE_FORMS);
  return /* @__PURE__ */ C(ie, {
    children: [
      (b || t) && /* @__PURE__ */ a(Or, {
        canAddForm: O(),
        disabled: u,
        loading: b,
        onAddForm: f,
        onSelectForm: g,
        tooltip: m,
        workflowStates: w
      }),
      !b && !t && /* @__PURE__ */ a(Ir, {
        canAddForm: O(),
        disabled: u,
        formContainerName: e.name,
        onAddForm: f,
        tooltip: m
      })
    ]
  });
}
Nr.propTypes = {
  formContainer: i.instanceOf(Tt).isRequired
};
function to() {
  const r = he(), { url: e } = Ee(), { id: t } = et(), s = Se(), { account: n } = $((b) => b.internalReducer.internal), { data: d, error: o, loading: l } = $((b) => b.formReducer.formHistory), { mounted: c } = Le({
    requiredValues: [
      n
    ]
  });
  V(() => (c && s(Un(t)), () => s(jn())), [
    c,
    t,
    s
  ]);
  const u = () => [
    {
      onClick: () => r.push(e.replace("/history", "")),
      type: L.BACK
    }
  ], m = () => [
    new k({
      ...H.VIEW_FORM,
      onClick: () => r.push(e.replace("/history", ""))
    }),
    new k({
      ...H.VIEW_FORM_VERSIONS,
      disabled: !d.version,
      onClick: () => r.push(e.replace("history", "versions"))
    })
  ], w = () => /* @__PURE__ */ a(Ue, {
    dropdownItems: d && m(),
    loading: l,
    rejected: d == null ? void 0 : d.isRejected(),
    subtitle: d && d.getFormattedSubtitle(),
    title: "Form History"
  });
  return o ? `Error: ${JSON.stringify(o, null, 2)}` : /* @__PURE__ */ a(fe, {
    buttons: u(),
    header: w(),
    loading: l,
    children: /* @__PURE__ */ C(ro, {
      children: [
        l && [
          ...Array(4).keys()
        ].map((b) => /* @__PURE__ */ a(we, {
          loading: l
        }, b)),
        !l && !d.history.length && "There is currently no history associated with this form",
        !l && d.history.map((b, h) => /* @__PURE__ */ C(Re.Fragment, {
          children: [
            /* @__PURE__ */ a(no, {
              ...x("form-history-record"),
              children: b.getFormattedHistory(d.id)
            }),
            h !== d.history.length - 1 && /* @__PURE__ */ a(J, {
              customStyles: {
                backgroundColor: R.grey.secondary
              }
            })
          ]
        }, b.id))
      ]
    })
  });
}
const ro = p(se).withConfig({
  displayName: "FormHistory__StyledList",
  componentId: "sc-e79618d7-0"
})([
  "gap:",
  ";padding:",
  " 0;overflow:auto;"
], y.medium, y.medium), no = p.div.withConfig({
  displayName: "FormHistory__HistoryRecord",
  componentId: "sc-e79618d7-1"
})([
  "color:",
  ";"
], R.grey.medium);
function Dr(r) {
  const { currentRoute: e, formContainer: t } = r, [s, n] = D(), [d, o] = D(""), l = he(), { url: c } = Ee(), u = Se(), { account: m, currentUser: w, disabled: b, tooltip: h, trialContainer: f } = $((S) => S.internalReducer.internal), { loading: g } = $((S) => S.formReducer.formCreation), { formTemplates: O, loading: _ } = zi({
    accountId: m == null ? void 0 : m.id
  }), { showErrorToast: ae, showSuccessToast: F } = Yt(), ee = (S) => {
    n(), o(S.target.value);
  }, B = (S) => (s == null ? void 0 : s.id) === S.id, z = async () => {
    !s || g || u(qn({
      formContainer: t,
      formTemplateId: s.id,
      onError: ae,
      onSuccess: (S) => {
        F("Form was added."), l.push(c.replace(`/${e.path}`, `/${S.id}`));
      }
    }));
  }, N = () => w == null ? void 0 : w.getTrialContainerPermissions().includes(ve.CAN_CREATE_FORMS), M = () => N() ? [
    {
      disabled: !s || g || b,
      id: "add-form",
      loading: g,
      onClick: z,
      text: "Add Form",
      tooltip: h,
      type: L.ACTION
    },
    {
      disabled: g,
      onClick: () => l.push(c.replace(`/${e.path}`, "")),
      type: L.BACK
    }
  ] : [], _e = (S) => {
    if (S.description)
      return [
        S.description
      ];
  };
  return /* @__PURE__ */ a(fe, {
    buttons: M(),
    header: /* @__PURE__ */ C(io, {
      children: [
        /* @__PURE__ */ a(oo, {
          children: "Select a form template"
        }),
        /* @__PURE__ */ a(be, {
          disabled: g || b,
          icon: q.baselineSearch,
          label: "Search templates",
          name: "Search templates",
          onChange: ee,
          value: d
        })
      ]
    }),
    loading: _,
    children: /* @__PURE__ */ C(so, {
      children: [
        _ && [
          ...Array(4).keys()
        ].map((S) => /* @__PURE__ */ a(we, {
          loading: _
        }, S)),
        !_ && !O.length && /* @__PURE__ */ C(we, {
          disabled: !0,
          children: [
            "No Form Templates have been assigned to your ",
            f.type
          ]
        }),
        !_ && /* @__PURE__ */ a(rn, {
          filterProperty: "title",
          filterValue: d,
          children: O.map((S) => /* @__PURE__ */ a(nn, {
            details: _e(S),
            disabled: g || b,
            icon: /* @__PURE__ */ a(Te, {
              height: 24,
              icon: q.renameBox,
              width: 24
            }),
            onClick: () => n(S),
            selected: B(S),
            title: S.title,
            value: S.id
          }, S.id))
        })
      ]
    })
  });
}
const io = p.div.withConfig({
  displayName: "SelectFormTemplate__Header",
  componentId: "sc-5fbbcd3-0"
})([
  "display:flex;flex-direction:column;gap:",
  ";"
], y.medium), oo = p.div.withConfig({
  displayName: "SelectFormTemplate__Title",
  componentId: "sc-5fbbcd3-1"
})([
  "font-size:",
  ";font-weight:",
  ";"
], pe.large, Ze.bold), so = p(se).withConfig({
  displayName: "SelectFormTemplate__Cards",
  componentId: "sc-5fbbcd3-2"
})([
  "padding:",
  " 0;overflow:auto;> div{flex-shrink:0;}"
], y.medium);
Dr.propTypes = {
  currentRoute: i.shape({
    path: i.string.isRequired
  }).isRequired,
  formContainer: i.instanceOf(Tt).isRequired
};
function ao() {
  const r = he(), { url: e } = Ee(), { id: t, versionNumber: s } = et(), n = Se(), { account: d } = $((h) => h.internalReducer.internal), { data: o, error: l, loading: c } = $((h) => h.formReducer.formVersion), { mounted: u } = Le({
    requiredValues: [
      d
    ]
  });
  V(() => (u && n(Bn(t, s)), () => n(zn())), [
    u,
    t,
    s,
    n
  ]);
  const m = () => [
    {
      onClick: () => r.push(e.replace(`/versions/${s}`, "/versions")),
      type: L.BACK
    }
  ], w = () => [
    new k({
      ...H.VIEW_FORM,
      onClick: () => r.push(e.replace(`/versions/${s}`, ""))
    }),
    new k({
      ...H.VIEW_FORM_VERSIONS,
      onClick: () => r.push(e.replace(`/versions/${s}`, "/versions"))
    }),
    new k({
      ...H.VIEW_FORM_HISTORY,
      disabled: !o.hasHistory,
      onClick: () => r.push(e.replace(`/versions/${s}`, "/history"))
    })
  ], b = () => /* @__PURE__ */ a(Ue, {
    description: o == null ? void 0 : o.description,
    dropdownItems: o && w(),
    loading: c,
    rejected: o == null ? void 0 : o.isRejected(),
    subtitle: o && o.getFormattedSubtitle(),
    title: o == null ? void 0 : o.title
  });
  return l ? `Error: ${JSON.stringify(l, null, 2)}` : /* @__PURE__ */ a(fe, {
    buttons: m(),
    header: b(),
    loading: c,
    children: /* @__PURE__ */ C(lo, {
      children: [
        c && /* @__PURE__ */ a(At, {}),
        !c && o && /* @__PURE__ */ C(ie, {
          children: [
            /* @__PURE__ */ a(qe, {
              form: o
            }),
            !!o.signatures.length && /* @__PURE__ */ a(Rt, {
              formId: `${o.id}`,
              formVersion: `${o.version}`,
              signatures: o.signatures
            })
          ]
        })
      ]
    })
  });
}
const lo = p.div.withConfig({
  displayName: "FormVersion__Content",
  componentId: "sc-3c32cde7-0"
})([
  "padding-top:",
  ";padding-bottom:",
  ";overflow:auto;"
], y.medium, y.medium);
function co() {
  const r = he(), { url: e } = Ee(), { id: t } = et(), s = Se(), { account: n } = $((h) => h.internalReducer.internal), { data: d, error: o, loading: l } = $((h) => h.formReducer.formVersions), { mounted: c } = Le({
    requiredValues: [
      n
    ]
  });
  V(() => (c && s(Pn(t)), () => s(Gn())), [
    c,
    t,
    s
  ]);
  const u = () => [
    {
      onClick: () => r.push(e.replace("/versions", "")),
      type: L.BACK
    }
  ], m = () => [
    new k({
      ...H.VIEW_FORM,
      onClick: () => r.push(e.replace("/versions", ""))
    }),
    new k({
      ...H.VIEW_FORM_HISTORY,
      disabled: !d.hasHistory,
      onClick: () => r.push(e.replace("versions", "history"))
    })
  ], w = (h) => {
    r.push(`${e}/${h.version}`);
  }, b = () => /* @__PURE__ */ a(Ue, {
    dropdownItems: d && m(),
    loading: l,
    rejected: d == null ? void 0 : d.isRejected(),
    subtitle: d && d.getFormattedSubtitle(),
    title: "Form Versions"
  });
  return o ? `Error: ${JSON.stringify(o, null, 2)}` : /* @__PURE__ */ a(fe, {
    buttons: u(),
    header: b(),
    loading: l,
    children: /* @__PURE__ */ C(uo, {
      children: [
        l && [
          ...Array(4).keys()
        ].map((h) => /* @__PURE__ */ a(we, {
          loading: l
        }, h)),
        !l && d.versions.map((h) => /* @__PURE__ */ a(Kt, {
          details: [
            `ID: ${h.id}`,
            `Title: ${h.title}`
          ],
          icon: /* @__PURE__ */ a(Te, {
            height: 24,
            icon: q.baselineAccessTime,
            width: 24
          }),
          onClick: () => w(h),
          title: h.getFormattedTitle()
        }, h.version))
      ]
    })
  });
}
const uo = p(se).withConfig({
  displayName: "FormVersions__StyledList",
  componentId: "sc-7839f1ef-0"
})([
  "padding:",
  " 0;overflow:auto;"
], y.medium), mo = [
  {
    component: Nr,
    name: "Forms",
    path: ""
  },
  {
    component: Dr,
    name: "Form template selection",
    path: "templates",
    permissions: [ve.CAN_CREATE_FORMS]
  },
  {
    component: Yi,
    name: "Form",
    path: ":id"
  },
  {
    component: co,
    name: "Form versions",
    path: ":id/versions"
  },
  {
    component: ao,
    name: "Form version",
    path: ":id/versions/:versionNumber"
  },
  {
    component: to,
    name: "Form history",
    path: ":id/history"
  }
];
function po(r) {
  const { account: e, authenticityToken: t, baseApiUrl: s, basePath: n, currentUser: d, disabled: o = !1, formContainer: l, onFormTransitionEnd: c = E, onNavigationBlockedChange: u = E, tooltip: m = "", trialContainer: w } = r;
  V(() => {
    qt.dispatch(Yn({
      account: e,
      authenticityToken: t,
      baseApiUrl: s,
      currentUser: d,
      disabled: o,
      formContainer: l,
      onFormTransitionEnd: c,
      onNavigationBlockedChange: u,
      tooltip: m,
      trialContainer: w
    }));
  });
  const b = (h) => h.permissions && !h.permissions.every((f) => d.getTrialContainerPermissions().includes(f)) ? /* @__PURE__ */ a(Mt, {
    to: n
  }) : /* @__PURE__ */ a(h.component, {
    currentRoute: h,
    formContainer: l
  });
  return /* @__PURE__ */ a(an, {
    store: qt,
    children: /* @__PURE__ */ C(ln, {
      children: [
        mo.map((h) => /* @__PURE__ */ a($t, {
          exact: !0,
          path: `${n}/${h.path}`,
          render: () => b(h)
        }, h.path)),
        /* @__PURE__ */ a($t, {
          render: () => /* @__PURE__ */ a(Mt, {
            to: n
          })
        })
      ]
    })
  });
}
po.propTypes = {
  account: i.instanceOf(On).isRequired,
  authenticityToken: i.string.isRequired,
  baseApiUrl: i.string.isRequired,
  basePath: i.string.isRequired,
  currentUser: i.instanceOf(Ct).isRequired,
  disabled: i.bool,
  formContainer: i.instanceOf(Tt).isRequired,
  onFormTransitionEnd: i.func,
  onNavigationBlockedChange: i.func,
  tooltip: i.string,
  trialContainer: i.instanceOf(Dn).isRequired
};
const xr = /* @__PURE__ */ on((r, e) => {
  const { error: t = null, formTemplate: s, loading: n = !1, onWatch: d = E, readOnly: o = !1 } = r, l = yt(), c = Qe(), { formState: { errors: u }, trigger: m, watch: w } = c;
  V(() => {
    const f = w((g) => d(g));
    return () => f.unsubscribe();
  }, [
    w,
    d
  ]);
  const b = (f) => {
    const g = Object.values(f);
    g.length && document.getElementById(g[0].ref.name).scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  sn(e, () => ({
    async validateForm() {
      const f = await m();
      return f || b(u), f;
    }
  }));
  const h = () => o ? /* @__PURE__ */ a(qe, {
    form: s
  }) : /* @__PURE__ */ a(It, {
    form: s,
    formMethods: c,
    scrollContainer: l
  });
  return t ? `Error: ${JSON.stringify(t, null, 2)}` : /* @__PURE__ */ C(ie, {
    children: [
      n && /* @__PURE__ */ a(At, {}),
      !n && /* @__PURE__ */ a(ho, {
        ref: l,
        children: h()
      })
    ]
  });
}), ho = p(se).withConfig({
  displayName: "FormBody__FormFields",
  componentId: "sc-7fdc3b96-0"
})([
  "gap:",
  ";padding:0;overflow:auto;"
], y.medium);
xr.displayName = "FormBody";
xr.propTypes = {
  error: i.shape({}),
  formTemplate: i.instanceOf(vt).isRequired,
  loading: i.bool,
  onWatch: i.func,
  readOnly: i.bool
};
export {
  On as Account,
  Xt as CheckboxFormField,
  Qt as DateFormField,
  Me as DateRestrictionType,
  Zt as DescriptiveFormField,
  er as DropdownFormField,
  X as Form,
  xr as FormBody,
  Tt as FormContainer,
  ko as FormContainerType,
  P as FormField,
  nr as FormFieldFactory,
  te as FormFieldType,
  vn as FormFieldValidations,
  Rn as FormHistory,
  vt as FormSimple,
  In as FormTemplate,
  po as FormsModule,
  Sn as Permissions,
  tr as RadioFormField,
  ir as Signature,
  wt as SignatureDefinition,
  rr as SingleLineFormField,
  Dn as TrialContainer,
  ve as TrialContainerPermissionType,
  Nn as TrialContainerType,
  Ct as User,
  le as UserType,
  En as WorkflowDefinition,
  bt as WorkflowState,
  _n as WorkflowStateOptions,
  re as WorkflowStateType,
  or as WorkflowTransition,
  An as WorkflowTransitionOptions
};
